<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin' && rol != 'admin-empresa' && rol != 'admin-sucursal' && rol != 'admin-depto'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container grid-list-xl fluid v-else>
            <v-row>
                <v-overlay :value="overlayDesgarga" >
                    <div class="align-center justify-center text-center">
                        <v-progress-circular
                            indeterminate
                            :size="100"
                            :width="7"
                            color="#2DB9D1"
                        >
                            <v-img
                                src="/static/icon/favicon.ico"
                                :width="60"
                            ></v-img>
                        </v-progress-circular>
                        <p>{{frase}}</p>
                    </div>
                </v-overlay>
                <v-col cols="12" lg="12">
                    <v-overlay :value="dialogOverlayEmpleados" :absolute="true" >
                        <div class="align-center justify-center text-center">
                            <v-progress-circular
                                indeterminate
                                :size="100"
                                :width="7"
                                color="#2DB9D1"
                            >
                                <v-img
                                    src="/static/icon/favicon.ico"
                                    :width="60"
                                ></v-img>
                            </v-progress-circular>
                            <p class="mt-5">{{'Subiendo empleados'}} - {{empleadosPorcentaje}} %</p>
                            <p>Procesados {{empleadosProcesados}} de {{empleadosTotal}}</p>
                        </div>
                    </v-overlay>
                    <data-table
                        ref="tableEmpleados"
                        :tableName="'Empleados'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        @loadModalData="loadModalData"
                        :perPage="[10, 25, 50, 100]"
                    >
                        <template
                            slot="actionButtonsLeft"
                            v-if="
                                rol == 'root' ||
                                rol == 'admin' ||
                                rol == 'admin-empresa' ||
                                rol == 'admin-sucursal'
                            "
                        >
                            <div class="botonAgregar" style="padding-right: 12px;" v-if="permisos.create">
                                <v-btn rounded color="#004BAF" class="btnAdd" right @click="abrirModal('add')">
                                <v-icon dark class="mr-2">add</v-icon>Agregar <div class="mr-4"></div></v-btn>
                            </div>
                        </template>

                        <template
                            v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa' || rol == 'admin-sucursal'"
                            slot="actionButtonsLeft"
                        >
                            <v-menu offset-y content-class="menuClassAcciones">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        dark
                                        class="btnAcciones pr-1 mr-3"
                                        v-bind="attrs"
                                        v-on="on"
                                        elevation="0"
                                    >
                                        Acciones 
                                        <template  v-for="(item,valor) in attrs" >
                                            <v-icon :key="valor" v-if="valor == 'aria-expanded' &&  item == 'true'" class="pl-2" color='#FFFFFF'>expand_less</v-icon>
                                            <v-icon :key="valor" v-if="valor == 'aria-expanded' &&  item == 'false'" class="pl-2" color='#FFFFFF'>expand_more</v-icon>
                                        </template>
                                    </v-btn>
                                    
                                </template>
                                <div class="btnAccionesContenedor">
                                    <div class="btnAccionesTitulo pb-6">
                                        <span>Layout de empleados</span>
                                    </div>

                                    <template v-if="rol == 'root' || rol == 'admin'">
                                        <div @click="abrirModalLayoutEmpleados('descargar')" class="btnAccionesItem py-2">
                                            <span>Descargar layout</span>
                                        </div>
                                        <div @click="abrirModalLayoutEmpleados('subir')" class="btnAccionesItem py-2">
                                            <span>Importar layout para agregar empleados</span><br />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div @click="layout()" class="btnAccionesItem py-2">
                                            <span>Descargar layout</span>
                                        </div>
                                        <div @click="modalLayout('importar')" class="btnAccionesItem py-2">
                                            <span>Importar layout para agregar empleados</span><br />
                                        </div>
                                    </template>
                                        

                                    <div class="btnAccionesTitulo pt-6 pb-4">
                                        <span>Layout con información de los empleados</span>
                                    </div>
                                    <template v-if="rol == 'root' || rol == 'admin'">
                                        <div @click="abrirModalLayoutEmpleados('exportar')" class="btnAccionesItem py-2">
                                            <span>Exportar carga masiva</span>
                                        </div>
                                        <div @click="abrirModalLayoutEmpleados('actulizacionMasivo')" class="btnAccionesItem py-2">
                                            <span>Actualizar carga masiva</span><br />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div @click="exportar()" class="btnAccionesItem py-2">
                                            <span>Exportar carga masiva</span>
                                        </div>
                                        <div @click="modalLayout('actulizacionMasivo')" class="btnAccionesItem py-2">
                                            <span>Actualizar carga masiva</span>
                                        </div>
                                    </template>
                                </div>
                            </v-menu>
                        </template>
                        <template slot="filters">
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                <template>
                                    <span class="RangoIngreso">Rango de fechas de ingreso</span>
                                </template>
                            </v-col>

                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    v-model="fecha_inicio"
                                    label="Fecha inicio"
                                    placeholder="dd/mm/aaaa"
                                    ref="FechaInicio"
                                />
                            </v-col>

                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    v-model="fecha_final"
                                    label="Fecha final"
                                    placeholder="dd/mm/aaaa"
                                    ref="FechaFinal"
                                />
                            </v-col>
                            <template v-if="rol == 'root'">
                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="clientes"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Cliente"
                                        persistent-hint
                                        v-model="cliente_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template v-if="rol == 'root' || rol == 'admin'">
                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="empresas"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Empresa"
                                        persistent-hint
                                        v-model="empresa_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="sucursales"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Sucursal"
                                        persistent-hint
                                        v-model="sucursal_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template
                                v-if="
                                rol == 'root' ||
                                    rol == 'admin' ||
                                    rol == 'admin-empresa' ||
                                    rol == 'admin-sucursal'
                                "
                            >
                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="departamentos"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Departamento"
                                        persistent-hint
                                        v-model="empleado.departamento_id"
                                    />
                                </v-col>
                            </template>

                            <v-col cols="12"
                                xs="12" 
                                :sm="(rol == 'admin' || rol == 'admin-sucursal') ? '6':'12'" 
                                :md="(rol == 'admin' || rol == 'admin-sucursal') ? '6':'12'" 
                                :lg="(rol == 'admin' || rol == 'admin-sucursal') ? '6':'12'" 
                                :xl="(rol == 'admin' || rol == 'admin-sucursal') ? '6':'12'"
                                v-if="rol != 'empleado'" class="py-0">

                                <v-text-field
                                    outlined
                                    label="Nombre"
                                    v-model="advancedSearch.empleado_correo"
                                ></v-text-field>

                            </v-col>

                            <v-col
                                cols="12"
                                xs="12"
                                sm="6"
                                md="6"
                                class="py-0"
                            >
                                <v-text-field
                                    outlined
                                    label="Correo"
                                    v-model="correo_search"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                xs="12"
                                sm="6"
                                md="6"
                                class="py-0"
                            >
                                <v-autocomplete
                                    outlined
                                    label="Categoría empleado"
                                    :items="categoriasEmpleado"
                                    item-text="nombre"
                                    item-value="id"
                                    v-model="categoria_empleado"
                                ></v-autocomplete>
                            </v-col>
                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td style="min-width:159px!important; max-width:161px!important; width:160px;padding-right:4px;">
                                    <div>{{ item.clave }}</div>
                                </td>
                                <td @click="detalleEmpleado(item)" class="cursor-pointer">
                                    <div>
                                        <v-list color="transparent" class="py-0 my-0">
                                            <v-list-item class="py-0 my-0 px-0">
                                                <v-list-item-avatar class="py-0 my-0">
                                                    <v-img class="py-0 my-0" :src="urlImg+item.foto"></v-img>
                                                </v-list-item-avatar>
                                                <v-list-item-content class="ml-0 py-0 my-0">
                                                    <v-list-item-title class="tblPrincipal" style="white-space: normal !important;">{{ item.nombre_completo }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </div>
                                </td>
                                <td>
                                    <div>{{ item.antiguedad }}</div>
                                </td>

                                <td>
                                    <!-- <v-rating
                                        readonly
                                        v-model="item.ranking"
                                        background-color="#F2F2F2"
                                        color="#2DB9D1"
                                        size="24"
                                        dense
                                    ></v-rating> -->
                                    <div class="d-flex align-center justify-center">
                                        <v-rating
                                            v-model="item.objRankig.length"
                                            size="24"
                                            dense
                                        >
                                            <template v-slot:item="props">
                                                <v-tooltip bottom v-if="props.isFilled">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :color="props.isFilled ? '#2DB9D1' : '#F2F2F2'"
                                                            class="mx-1"
                                                        >
                                                            {{ props.isFilled ? 'mdi-star' : 'mdi-star' }}
                                                        </v-icon>
                                                    </template>
                                                    <span v-if="props.isFilled">{{item.objRankig[props.index]}}</span>
                                                </v-tooltip>

                                                <v-icon
                                                    v-else
                                                    :color="props.isFilled ? '#2DB9D1' : '#F2F2F2'"
                                                    class="mx-1"
                                                >
                                                    {{ props.isFilled ? 'mdi-star' : 'mdi-star' }}
                                                </v-icon>
                                            </template>
                                        </v-rating>
                                    </div>
                                </td>
                                <td style="min-width:290px!important; max-width:301px!important; width:300px; padding-left:8px; padding-right:8px;">
                                    <div class="tblOpcionesBtn">

                                        <v-menu buttom left class="elevation-0 d-inline" content-class="mt-0 menuClassAccionesEmpleado"> 
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    icon 
                                                    fab
                                                    dark
                                                    small
                                                    class="elevation-0"
                                                >
                                                    <template  v-for="(item,valor) in attrs" >
                                                        <v-icon :key="valor" v-if="valor == 'aria-expanded' &&  item == 'false'" class="pl-2" color='#828282'>more_vert</v-icon>
                                                        <v-icon :key="valor" v-if="valor == 'aria-expanded' &&  item == 'true'" class="pl-2" color='#2DB9D1'>more_vert</v-icon>
                                                    </template>
                                                </v-btn>
                                            </template>

                                            <v-list>
                                                <v-list-item
                                                    @click="abrirModal('checadores', item)"
                                                >
                                                    <v-list-item-title>Checadores</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    @click="abrirModalClave(item)" 
                                                >
                                                    <v-list-item-title>Clave checador</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    @click="detalle_documentos(item)"
                                                >
                                                    <v-list-item-title>Documentos</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    @click="abrirModal('update', item)"  
                                                    v-if="rol != 'admin-depto' && rol != 'empleado'"
                                                >
                                                    <v-list-item-title>Editar</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                        
                                        <template v-if="computedSistema">
                                            <template v-if="permisos.delete">
                                                <v-tooltip bottom v-if="rol != 'admin-depto' && rol != 'empleado'">
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-on="on"
                                                            slot="activator"
                                                            class="botonHover"
                                                            icon
                                                            fab
                                                            dark
                                                            small
                                                            @click="abrirModal('baja', item)"
                                                        >
                                                            <v-icon class="tamIconoBoton iconoDelgadoBotonDelete">arrow_downward</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Baja Empleado</span>
                                                </v-tooltip>
                                            </template>
                                            <template v-if="permisos.delete">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn 
                                                            v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa' || rol == 'admin-sucursal'"
                                                            v-on="on" 
                                                            @click="eliminar(item.id, item.nombre, item.correo)" 
                                                            class="botonHover" 
                                                            icon 
                                                            fab 
                                                            dark 
                                                            small
                                                        >
                                                            <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Eliminar</span>
                                                </v-tooltip>
                                            </template>
                                        </template>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <!--MODAL KARDEX-->
        <template>
            <v-layout row justify-center>
                <v-dialog v-model="dialog" persistent :max-width="tamModal" scrollable>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal" style="overflow-x: scroll;"></v-btn>
                    </template>
                    <perfect-scrollbar style="background:#FFF">
                        <v-card elevation="0">
                            <ValidationObserver ref="form" v-slot="{ invalid }">
                                <v-card-title class="justify-center card_titulo">
                                    <div class="headerModal">
                                        <img :src="ImagenModal" class="imgModal" />
                                        <h2 class="titleModal">{{ titulo_modal }}</h2>
                                    </div>
                                </v-card-title>

                                <v-card-text :class="accion === 'checadores' ? 'px-0':'card_texto'">
                                    <div id="loadingModal" v-show="!finaliza_carga">
                                        <div id="loading">
                                            <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular>
                                        </div>
                                    </div>

                                    <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                        <v-divider class="divider"  v-if="accion != 'checadores'"></v-divider>
                                        <template v-if="accion === 'add' || accion === 'update'">
                                            <v-row>
                                                <!-- Nombre -->
                                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Nombre" rules="required">
                                                        <v-text-field
                                                            id="primero"
                                                            autofocus
                                                            outlined
                                                            label="Nombre(s)"
                                                            v-model="empleado.nombre"
                                                            :error-messages="errors" 
                                                            required
                                                        />
                                                    </ValidationProvider>
                                                </v-col>

                                                <!-- Apellido Paterno -->
                                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Apellido Paterno" rules="required">
                                                        <v-text-field
                                                            outlined
                                                            label="Apellido paterno"
                                                            class="estiloLetras"
                                                            v-model="empleado.apellido_paterno"
                                                            :error-messages="errors" 
                                                            required
                                                        />
                                                    </ValidationProvider>
                                                </v-col>

                                                <!-- Apellido Materno -->
                                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                    <v-text-field
                                                        outlined
                                                        label="Apellido materno"
                                                        class="estiloLetras"
                                                        v-model="empleado.apellido_materno"
                                                    />
                                                </v-col>

                                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0 ma-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Nacionalidad" rules="required">
                                                        <v-text-field 
                                                            outlined
                                                            label="Nacionalidad"
                                                            v-model="empleado.nacionalidad"
                                                            class="pa-0 ma-0"
                                                            id="txtNacionalidad"
                                                            :error-messages="errors" 
                                                            required
                                                        >
                                                        </v-text-field>
                                                    </ValidationProvider>
                                                </v-col>

                                                <!-- Sexo -->
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="pt-0 pb-0 ma-0">
                                                    <template>
                                                        <v-container class="ma-0 pa-0" fluid>
                                                            <h4 class="tituloRadio">Sexo</h4>
                                                            <v-radio-group class="ma-0 pa-0" v-model="empleado.sexo" row>
                                                                <v-radio label="Masculino" value="M"></v-radio>
                                                                <v-radio label="Femenino" value="F"></v-radio>
                                                            </v-radio-group>
                                                        </v-container>
                                                    </template>
                                                </v-col>

                                                <!-- Estadio civil -->
                                                <!-- <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="pt-0 pb-0 ma-0">
                                                    <template>
                                                        <v-container class="ma-0 pa-0" fluid>
                                                            <h4 class="tituloRadio">Estado civil</h4>
                                                            <v-radio-group class="ma-0 pa-0" v-model="empleado.estado_civil_id" row>
                                                                <v-radio label="Soltero" :value="1"></v-radio>
                                                                <v-radio label="Casado" :value="2"></v-radio>
                                                            </v-radio-group>
                                                        </v-container>
                                                    </template>
                                                </v-col> -->
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="pt-0 pb-0 ma-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Estado civil" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            label="Estado civil"
                                                            :items="estados_civiles"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            persistent-hint
                                                            v-model="empleado.estado_civil_id"
                                                            class="pa-0 ma-0"
                                                            required 
                                                            :error-messages="errors" 
                                                            id="txtEstadoCivil"
                                                        >
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>

                                                <!-- Tiene hijos -->
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="mt-3">
                                                    <v-container class="ma-0 pa-0" fluid>
                                                        <v-checkbox
                                                            class="pa-0 ma-0"
                                                            v-model="empleado.tiene_hijos"
                                                            label="Tiene Hijo(s)"
                                                        ></v-checkbox>
                                                    </v-container>
                                                </v-col>

                                                <!-- Fecha de Nacimiento -->
                                                <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3" class="py-0">
                                                    <VuetifyDatePicker
                                                        outlined
                                                        v-model="empleado.fecha_nacimiento"
                                                        label="Fecha de nacimiento"
                                                        placeholder="dd/mm/aaaa"
                                                        rules="required"
                                                        ref="FechaNacimiento"
                                                    />
                                                </v-col>
                                                <!-- Dirección -->
                                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Dirección" rules="required">
                                                        <v-text-field
                                                            outlined
                                                            label="Dirección"
                                                            v-model="empleado.direccion"
                                                            :error-messages="errors" 
                                                            required
                                                        />
                                                    </ValidationProvider>
                                                </v-col>

                                                <!-- codigo postal -->
                                                <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="CP" rules="required">
                                                        <v-text-field
                                                            outlined
                                                            label="Código postal"
                                                            v-model="busca_cp"
                                                            @keyup.enter="busca_codigos()"
                                                            v-mask="'#####'"
                                                            :error-messages="errors" 
                                                            required
                                                        />
                                                    </ValidationProvider>
                                                </v-col>

                                                <!-- Estados -->
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <v-text-field outlined label="Estado" v-model="estado" disabled />
                                                </v-col>

                                                <!-- Ciudades -->
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <v-text-field outlined label="Municipio" v-model="ciudad" disabled />
                                                </v-col>

                                                <!-- Colonia -->
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Colonia" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            :items="colonias"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            label="Colonia"
                                                            persistent-hint
                                                            v-model="empleado.colonia_id"
                                                            :error-messages="errors" 
                                                            required
                                                        >
                                                            <template v-if="mColonia"  v-slot:append-item>
                                                                <v-list-item>             
                                                                    <v-list-item-content class="cursor-pointer"  @click="abrirModalColonia()">
                                                                        <v-list-item-title style="color:#007EFF">Agregar colonia</v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </template>   
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>

                                                <!-- Telefono -->
                                                <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Teléfono" rules="required">
                                                        <v-text-field
                                                            outlined
                                                            label="Teléfono"
                                                            v-model="empleado.telefono"
                                                            v-mask="'(###) ###-####'"
                                                            placeholder="(999) 999-9999"
                                                            :error-messages="errors"
                                                            required
                                                            auto
                                                        />
                                                    </ValidationProvider>
                                                </v-col>

                                                <!-- Estudios -->
                                                <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Escolaridad" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            :items="estudios"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            label="Escolaridad"
                                                            persistent-hint
                                                            v-model="empleado.nivel_estudios_id"
                                                            :error-messages="errors"
                                                            required
                                                        />
                                                    </ValidationProvider>
                                                </v-col>

                                                <!-- Correo -->
                                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="6" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Correo eléctronico" rules="email" >
                                                        <v-text-field
                                                            outlined
                                                            label="Email"
                                                            v-model="empleado.correo"
                                                            id="Correo"
                                                            :error-messages="errors"
                                                            required
                                                        />
                                                    </ValidationProvider>
                                                </v-col>

                                                <v-col cols="12" xs="12" sm="6" md="6" class="pt-0 pb-0 ma-0">
                                                    <ValidationProvider v-slot="{ errors }" name="RFC" rules="required|rfc">
                                                        <v-text-field 
                                                            outlined
                                                            label="RFC" 
                                                            class="pa-0 ma-0" 
                                                            maxlength="13"
                                                            v-model="empleado.rfc"
                                                            :error-messages="errors" 
                                                            required
                                                            id="txtRFC"
                                                        >
                                                        </v-text-field>
                                                    </ValidationProvider>
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="6" md="6" class="pt-0 pb-0 ma-0">
                                                    <ValidationProvider v-slot="{ errors }" name="CURP" rules="required|curp">
                                                        <v-text-field 
                                                            outlined
                                                            label="CURP" 
                                                            maxlength="18"
                                                            class="pa-0 ma-0" 
                                                            v-model="empleado.curp"
                                                            :error-messages="errors" 
                                                            required
                                                            id="txtCURP"
                                                        >
                                                        </v-text-field>
                                                    </ValidationProvider>
                                                </v-col>
                                            </v-row>
                                            <v-col cols="12" xs="12" md="12" lg="12" xl="12" class="division mt-2 mb-6"></v-col>
                                            <v-row>
                                            
                                                <!-- Clientes -->
                                                <template v-if="rol == 'root'">
                                                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                        <ValidationProvider v-slot="{ errors }" name="Cliente" rules="required">
                                                            <v-autocomplete
                                                                outlined
                                                                :items="clientes"
                                                                item-text="nombre"
                                                                item-value="id"
                                                                class="estiloLetras"
                                                                label="Cliente"
                                                                persistent-hint
                                                                v-model="cliente_value"
                                                                :error-messages="errors"
                                                                required
                                                            />
                                                        </ValidationProvider>
                                                    </v-col>
                                                </template>
                                                <!-- Empresas -->
                                                <template v-if="rol == 'root' || rol == 'admin'">
                                                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                        <ValidationProvider v-slot="{ errors }" name="Empresa" rules="required">
                                                            <v-autocomplete
                                                                outlined
                                                                :items="empresas"
                                                                item-text="nombre"
                                                                item-value="id"
                                                                class="estiloLetras"
                                                                label="Empresa"
                                                                persistent-hint
                                                                v-model="empresa_value"
                                                                :error-messages="errors"
                                                                required
                                                                ref="autoEmpresa"
                                                            >
                                                            <template v-if="rol == 'root' || rol=='admin'"  v-slot:append-item>
                                                                <v-list-item>             
                                                                    <v-list-item-content class="cursor-pointer"  @click="abrirModalAgregar('tEmpresa')">
                                                                        <v-list-item-title style="color:#007EFF">Agregar empresa</v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </template>
                                                            </v-autocomplete>
                                                        </ValidationProvider>
                                                    </v-col>
                                                </template>
                                                <!-- Sucursales -->
                                                <template
                                                    v-if="
                                                        rol == 'root' ||
                                                        rol == 'admin' ||
                                                        rol == 'admin-empresa'
                                                    "
                                                >
                                                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                        <ValidationProvider v-slot="{ errors }" name="Sucursal" rules="required">
                                                            <v-autocomplete
                                                                outlined
                                                                :items="sucursales"
                                                                item-text="nombre"
                                                                item-value="id"
                                                                class="estiloLetras"
                                                                label="Sucursal"
                                                                persistent-hint
                                                                v-model="sucursal_value"
                                                                :error-messages="errors"
                                                                required
                                                                ref="autoSucursal"
                                                            >
                                                                <template v-if="mSucursal"  v-slot:append-item>
                                                                    <v-list-item>             
                                                                        <v-list-item-content class="cursor-pointer"  @click="abrirModalAgregar('tSucursal')">
                                                                            <v-list-item-title style="color:#007EFF">Agregar sucursal</v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </template>
                                                            </v-autocomplete>
                                                        </ValidationProvider>
                                                    </v-col>
                                                </template>

                                                <!-- Departamentos  visa solo root-->
                                                <template v-if="rol == 'root' || rol == 'admin-sucursal'">
                                                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                        <ValidationProvider v-slot="{ errors }" name="Departamento" rules="required">
                                                            <v-autocomplete
                                                                outlined
                                                                :items="departamentos"
                                                                item-text="nombre"
                                                                item-value="id"
                                                                class="estiloLetras"
                                                                label="Departamento"
                                                                persistent-hint
                                                                v-model="empleado.departamento_id"
                                                                :error-messages="errors"
                                                                required
                                                                ref="autoDepartamento"
                                                            >
                                                                <template v-if="mDeptos"  v-slot:append-item>
                                                                    <v-list-item>             
                                                                        <v-list-item-content class="cursor-pointer"  @click="abrirModalAgregar('tDepto')">
                                                                            <v-list-item-title style="color:#007EFF">Agregar departamento</v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </template>
                                                            </v-autocomplete>
                                                        </ValidationProvider>
                                                    </v-col>
                                                </template>
                                                <!-- Horarios vista solo root-->
                                                <template v-if="rol == 'root' || rol == 'admin-sucursal'">
                                                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                        <ValidationProvider v-slot="{ errors }" name="Horario" rules="required">
                                                            <v-autocomplete
                                                                outlined
                                                                :items="horarios"
                                                                item-text="nombre"
                                                                item-value="id"
                                                                class="estiloLetras"
                                                                label="Horario"
                                                                persistent-hint
                                                                v-model="empleado.horario_id"
                                                                :error-messages="errors"
                                                                required
                                                                ref="autoHorario"
                                                            >
                                                                <template v-if="mReloj"  v-slot:append-item>
                                                                    <v-list-item>             
                                                                        <v-list-item-content class="cursor-pointer"  @click="abrirModalAgregar('tHorario')">
                                                                            <v-list-item-title style="color:#007EFF">Agregar horario</v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </template>
                                                            </v-autocomplete>
                                                        </ValidationProvider>
                                                    </v-col>
                                                </template>

                                                <!-- Puestos -->
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Puesto" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            :items="computedPuestos"
                                                            item-text="claveNombre"
                                                            item-value="id"
                                                            label="Puesto"
                                                            persistent-hint
                                                            v-model="empleado.puesto_id"
                                                            :error-messages="errors"
                                                            required
                                                            ref="autoPuesto"
                                                        >
                                                            <template v-if="mPuesto"  v-slot:append-item>
                                                                <v-list-item>             
                                                                    <v-list-item-content class="cursor-pointer"  @click="abrirModalAgregar('tPuesto')">
                                                                        <v-list-item-title style="color:#007EFF">Agregar puesto</v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </template>
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>
                                                <!-- Departamentos -->
                                                <template v-if="rol == 'admin' || rol == 'admin-empresa'">
                                                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                        <ValidationProvider v-slot="{ errors }" name="Departamento" rules="required">
                                                            <v-autocomplete
                                                                outlined
                                                                :items="departamentos"
                                                                item-text="nombre"
                                                                item-value="id"
                                                                class="estiloLetras"
                                                                label="Departamento"
                                                                persistent-hint
                                                                v-model="empleado.departamento_id"
                                                                :error-messages="errors"
                                                                required
                                                                ref="autoDepartamento"
                                                            >
                                                                <template v-if="mDeptos"  v-slot:append-item>
                                                                    <v-list-item>             
                                                                        <v-list-item-content class="cursor-pointer"  @click="abrirModalAgregar('tDepto')">
                                                                            <v-list-item-title style="color:#007EFF">Agregar departamento</v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </template>
                                                            </v-autocomplete>
                                                        </ValidationProvider>
                                                    </v-col>
                                                </template>
                                                <!-- Horarios -->
                                                <template
                                                    v-if="
                                                        rol == 'admin' ||
                                                        rol == 'admin-empresa' ||
                                                        rol == 'admin-depto'
                                                    "
                                                >
                                                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                        <ValidationProvider v-slot="{ errors }" name="Horario" rules="required">
                                                            <v-autocomplete
                                                                outlined
                                                                :items="horarios"
                                                                item-text="nombre"
                                                                item-value="id"
                                                                class="estiloLetras"
                                                                label="Horario"
                                                                persistent-hint
                                                                v-model="empleado.horario_id"
                                                                :error-messages="errors"
                                                                required
                                                                ref="autoHorario"
                                                            >
                                                                <template v-if="mReloj"  v-slot:append-item>
                                                                    <v-list-item>             
                                                                        <v-list-item-content class="cursor-pointer"  @click="abrirModalAgregar('tHorario')">
                                                                            <v-list-item-title style="color:#007EFF">Agregar horario</v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </template>
                                                            </v-autocomplete>
                                                        </ValidationProvider>
                                                    </v-col>
                                                </template>
                                                <!-- Fecha de ingreso -->
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <VuetifyDatePicker
                                                        outlined
                                                        v-model="empleado.fecha_ingreso"
                                                        label="Fecha de ingreso"
                                                        placeholder="dd/mm/aaaa"
                                                        rules="required"
                                                        ref="FechaIngreso"
                                                    />
                                                </v-col>

                                                <!-- Prestaciones -->
                                                <template
                                                    v-if="
                                                        rol == 'root' ||
                                                        rol == 'admin' ||
                                                        rol == 'admin-empresa' ||
                                                        rol == 'admin-sucursal'
                                                    "
                                                >
                                                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                        <ValidationProvider v-slot="{ errors }" name="Prestaciones" rules="required">
                                                            <v-autocomplete
                                                                outlined
                                                                :items="prestaciones"
                                                                item-text="nombre"
                                                                item-value="id"
                                                                class="estiloLetras"
                                                                label="Prestación"
                                                                persistent-hint
                                                                v-model="empleado.prestacion_id"
                                                                :error-messages="errors"
                                                                required
                                                            />
                                                        </ValidationProvider>
                                                    </v-col>
                                                </template>
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Periodicidad" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            label="Periodicidad"
                                                            :items="periodicidades"
                                                            item-text="descripcion"
                                                            item-value="id"
                                                            persistent-hint
                                                            v-model="empleado.periodicidad_id"
                                                            class="pa-0 ma-0"
                                                            required 
                                                            :error-messages="errors"
                                                        >
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="4" md="4"  lg="4" xl="4" class=" py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Régimen de contratación" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            label="Régimen de contratación"
                                                            :items="tiposRegimenesSAT"
                                                            v-model="empleado.tipo_regimen_sat_id"
                                                            item-text="claveDescripcion"
                                                            item-value="id"
                                                            class="pa-0 ma-0"
                                                            required 
                                                            :error-messages="errors" 
                                                        >
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <VuetifyMoneyValidate
                                                        rules="required"
                                                        outlined
                                                        label="Sueldo diario"
                                                        class="pa-0 ma-0"
                                                        prefix="$"
                                                        v-model="empleado.salario_diario"
                                                        v-bind:options="options"
                                                        ref="salario_diario"
                                                        :readonly="accion == 'update'? true:false"
                                                    >
                                                        <template v-if="accion == 'update'" v-slot:append-icon>
                                                            <v-btn
                                                                class="elevation-0 ma-0 pa-0 v-btn-hover"
                                                                color="transparent"
                                                                @click="abrirModalSueldo('sueldo')"
                                                                rounded
                                                                :ripple="false" 
                                                            >
                                                                <v-icon color="white" class="tamIconoBoton invertirColorBotones">
                                                                    edit
                                                                </v-icon>
                                                            </v-btn>
                                                        </template>
                                                    </VuetifyMoneyValidate>
                                                </v-col>

                                                <!-- Clave Interna -->
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <v-text-field
                                                        outlined
                                                        label="Clave interna"
                                                        class="estiloLetras"
                                                        v-model="empleado.clave_interna"                                                        
                                                    />
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <v-autocomplete
                                                        outlined
                                                        label="Brigadas"
                                                        :items="itemsBrigadas"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        persistent-hint
                                                        v-model="empleado.brigada_proteccion_civil_id"
                                                        class="pa-0 ma-0"
                                                    >   
                                                    </v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Tipo contrato" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            label="Tipo contrato"
                                                            :items="contratos"
                                                            item-text="claveDescripcion"
                                                            item-value="id"
                                                            persistent-hint
                                                            v-model="empleado.tipo_contrato_id"
                                                            :error-messages="errors"
                                                            required
                                                            id="txtTipoContrato"
                                                        >
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>
                                                <!-- <v-col v-if="dosContratos && accion == 'add'" cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Tipo contrato" rules="required">
                                                        <v-autocomplete
                                                        outlined
                                                        label="Segundo contrato"
                                                        :items="contratos"
                                                        item-text="claveDescripcion"
                                                            item-value="id"
                                                            persistent-hint
                                                            v-model="empleado.segundo_contrato_tipo_contrato_id"
                                                            :error-messages="errors"
                                                            required
                                                            id="txtTipoContrato"
                                                            >
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col> -->
                                                 <!--Categoria Empleado-->
                                                 <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                        <v-autocomplete
                                                            outlined
                                                            label="Categoría empleado"
                                                            :items="categoriasEmpleado"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            persistent-hint
                                                            v-model="empleado.empleado_categoria_id"
                                                        >
                                                        </v-autocomplete>
                                                </v-col>
                                                <v-col v-if="determinado" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                    <v-container class="ma-0 pa-0" fluid>
                                                        <h4 class="tituloRadio">Elije el periodo del tiempo determinado</h4>
                                                        <v-radio-group class="ma-0 pa-0" v-model.number="empleado.dias_contrato" row>
                                                            <v-radio label="30 días" :value="30"></v-radio>
                                                            <v-radio label="60 días" :value="60"></v-radio>
                                                            <v-radio label="90 días" :value="90"></v-radio>
                                                            <v-radio label="180 días" :value="180"></v-radio>
                                                        </v-radio-group>
                                                    </v-container>
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Tipo contrato" rules="required">
                                                        <v-textarea
                                                            v-model="empleado.direccion_contrato"
                                                            outlined
                                                            label="Dirección contrato"
                                                            rows="3"
                                                            required 
                                                            :error-messages="errors" 
                                                        ></v-textarea>
                                                    </ValidationProvider>
                                                </v-col>
                                                <!-- Vacaciones -->
                                                <template>
                                                    <v-col class="py-0" v-if="'admin-empresa'" cols="12" xs="4" sm="4" md="4" lg="4" xl="4">
                                                        <ValidationProvider v-slot="{ errors }" name="Días de vacaciones" rules="required">
                                                            <v-text-field
                                                                outlined
                                                                label="Días de vacaciones"
                                                                v-model="empleado.dias_vacaciones"
                                                                mask="##"
                                                                :error-messages="errors"
                                                                required
                                                            />
                                                        </ValidationProvider>
                                                    </v-col>

                                                    <v-col v-else cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                        <ValidationProvider v-slot="{ errors }" name="Días de vacaciones" rules="required">
                                                            <v-text-field
                                                                outlined
                                                                label="Días de vacaciones"
                                                                readonly
                                                                v-model="empleado.dias_vacaciones"
                                                                mask="##"
                                                                :error-messages="errors"
                                                                required
                                                            />
                                                        </ValidationProvider>
                                                    </v-col>
                                                </template>


                                                <template>
                                                    <template
                                                        v-if="
                                                        (rol == 'root' ||
                                                            rol == 'admin' ||
                                                            rol == 'admin-empresa' ||
                                                            rol == 'admin-sucursal' ||
                                                            rol == 'admin-depto') &&
                                                            accion === 'add'
                                                        "
                                                    >
                                                        <template>
                                                            <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                                <v-menu offset-y elevation="0" content-class="menuClassFoto" z-index="999">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-text-field
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                            v-model="archivo_adjunto"
                                                                            outlined
                                                                            label="Foto empleado"
                                                                            type="text"
                                                                            hide-details
                                                                            readonly
                                                                        > 
                                                                            <template slot="append">
                                                                                <v-icon v-bind="attrs" v-on="on">arrow_drop_down</v-icon>
                                                                            </template>
                                                                        </v-text-field>                                                                    
                                                                    </template>
                                                                    <v-text-field
                                                                        outlined
                                                                        id="form"
                                                                        readonly
                                                                        label="Adjuntar desde galería"
                                                                        @click="almacenarImagen"
                                                                        v-model="nombreImagen"
                                                                        hide-details
                                                                        class="pt-2 v-text-field-foto"
                                                                    >
                                                                        <template slot="append">
                                                                            <v-icon @click="almacenarImagen" class="tamIcono">attach_file</v-icon>
                                                                        </template>
                                                                    </v-text-field>
                                                                    <input
                                                                        type="file"
                                                                        style="display: none"
                                                                        ref="imagen"
                                                                        accept="image/*"
                                                                        id="avatar"
                                                                        @change="onFilePickedImagen"
                                                                    />
                                                                
                                                                
                                                                    <v-text-field
                                                                        outlined
                                                                        id="form2"
                                                                        readonly
                                                                        label="Tomar fotografía"
                                                                        @click="abrirModalFoto('capturar')"
                                                                        v-model="nombreFoto"
                                                                        hide-details
                                                                        class="pt-2 v-text-field-foto"
                                                                    >
                                                                        <template slot="append">
                                                                            <v-icon @click="abrirModalFoto('capturar')" class="tamIcono invertirColor" >camera_alt</v-icon>
                                                                        </template>
                                                                    </v-text-field>
                                                                </v-menu>
                                                            </v-col>
                                                            <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                                <v-avatar>
                                                                    <img id="img" src="/static/avatar/usuario4.jpg" width="130px" />
                                                                </v-avatar>
                                                            </v-col>
                                                        </template>
                                                    </template>


                                                
                                                    <template v-if="accion === 'update'">
                                                        <template>
                                                            <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                                <v-menu offset-y elevation="0" content-class="menuClassFoto" z-index="999">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-text-field
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                            v-model="archivo_adjunto"
                                                                            outlined
                                                                            label="Foto empleado"
                                                                            type="text"
                                                                            hide-details
                                                                            readonly
                                                                        > 
                                                                            <template slot="append">
                                                                                <v-icon v-bind="attrs" v-on="on">arrow_drop_down</v-icon>
                                                                            </template>
                                                                        </v-text-field>                                                                    
                                                                    </template>
                                                                    <v-text-field
                                                                        outlined
                                                                        id="form"
                                                                        readonly
                                                                        label="Adjuntar desde galería"
                                                                        @click="almacenarImagen"
                                                                        v-model="nombreImagen"
                                                                        hide-details
                                                                        class="pt-2 v-text-field-foto"
                                                                    >
                                                                        <template slot="append">
                                                                            <v-icon @click="almacenarImagen" class="tamIcono">attach_file</v-icon>
                                                                        </template>
                                                                    </v-text-field>
                                                                    <input
                                                                        type="file"
                                                                        style="display: none"
                                                                        ref="imagen"
                                                                        accept="image/*"
                                                                        id="avatar"
                                                                        @change="onFilePickedImagen"
                                                                    />
                                                                
                                                                
                                                                    <v-text-field
                                                                        outlined
                                                                        id="form2"
                                                                        readonly
                                                                        label="Tomar fotografía"
                                                                        @click="abrirModalFoto('capturar')"
                                                                        v-model="nombreFoto"
                                                                        hide-details
                                                                        class="pt-2 v-text-field-foto"
                                                                    >
                                                                        <template slot="append">
                                                                            <v-icon @click="abrirModalFoto('capturar')" class="tamIcono invertirColor" >camera_alt</v-icon>
                                                                        </template>
                                                                    </v-text-field>
                                                                </v-menu>
                                                            </v-col>
                                                            <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                                <v-avatar>
                                                                    <img id="img" :src="empleado.foto" width="130px" />
                                                                </v-avatar>
                                                            </v-col>
                                                            

                                                        </template>
                                                    </template>
                                                    <v-col cols="12" xs="12" md="12" class="mt-3">
                                                        <h4 class="tituloRadio">Puntos adicionales</h4>
                                                    </v-col>
                                                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="mt-3">
                                                        <v-container class="ma-0 pa-0" fluid>
                                                            <v-switch
                                                                class="pa-0 ma-0"
                                                                v-model="empleado.ambiente_laboral"
                                                                label="Puntos por clima laboral"
                                                            ></v-switch>
                                                        </v-container>
                                                    </v-col>

                                                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="mt-3">
                                                        <v-container class="ma-0 pa-0" fluid>
                                                            <v-switch
                                                                class="pa-0 ma-0"
                                                                v-model="empleado.mejora_continua"
                                                                label="Puntos por mejora proyectos"
                                                            ></v-switch>
                                                        </v-container>
                                                    </v-col>
                                                </template>

                                                <!-- Capacitaciones -->
                                                
                                                <v-col cols="12" xs="12" md="12">
                                                    <v-divider></v-divider>
                                                    <h3 class="subtituloCapacitacion mt-7 ml-2">Capacitaciones</h3>
                                                </v-col>
                                                    <v-col cols="12" xs="12" md="3" class="mt-2">
                                                        <v-autocomplete
                                                            outlined
                                                            label="Curso"
                                                            :items="itemsCursosCapacitaciones"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            persistent-hint
                                                            v-model="curso_id"
                                                        >
                                                        </v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12" xs="12" md="2" class="my-2">
                                                        <v-text-field
                                                            outlined
                                                            label="Evaluación"
                                                            type="number"
                                                            v-mask="'###'"
                                                            min="0"
                                                            max="100"
                                                            onkeyup="if(this.value > 100 || this.value<0) this.value = 0;"
                                                            v-model="evaluacion" 
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" xs="12" md="6" class="my-2">
                                                        <v-text-field 
                                                            outlined
                                                            label="Observaciones" 
                                                            v-model="observaciones"
                                                        ></v-text-field>
                                                    </v-col>
                                                    
                                                    <v-col cols="12" xs="12" md="1" class="my-2">
                                                        <v-btn color="#1E2245" class="mt-2" elevation="0" dark fab  @click="agregarCurso()" small>
                                                            <v-icon dark>add</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                    
                                                    <template v-for="(i,index) in empleado.cursos_capacitaciones">
                                                        <v-col cols="12" xs="12" sm="12" md="3" :key="i.id" class="pt-0 pb-0 ma-0">
                                                            <v-text-field label="Curso" outlined disabled type="text" :value="i.nombre"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" xs="12" sm="5" md="2" :key="'H'+i.id" class="pt-0 pb-0 ma-0">
                                                            <v-text-field type="text" label="Evaluación" outlined :value="i.evaluacion" disabled ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" xs="12" sm="5" md="6" :key="'I'+i.id" class="pt-0 pb-0 ma-0">
                                                            <v-text-field type="text" label="Observaciones" outlined :value="i.observaciones" disabled ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" xs="12" md="1" :key="'K'+i.id" class="py-2">
                                                            <v-btn class="botonHover" icon fab dark small @click="eliminaCurso(index, i)" >
                                                                <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </template>
                                            </v-row>
                                        </template>

                                        <template v-if="accion === 'baja'">
                                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pa-0">
                                                    <v-text-field
                                                        outlined
                                                        class="estiloLetras"
                                                        label="Nombre"
                                                        v-model="nombreBaja"
                                                        disabled
                                                    />
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pa-0">
                                                    <VuetifyDatePicker
                                                        outlined
                                                        v-model="baja.fecha"
                                                        label="Fecha de baja"
                                                        placeholder="dd/mm/aaaa"
                                                        rules="required"
                                                        ref="FechaBaja"
                                                    />
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pa-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Tipo de baja" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            :items="tipos_baja_imss"
                                                            item-text="descripcion"
                                                            item-value="id"
                                                            label="Tipo de baja ante el IMSS"
                                                            persistent-hint
                                                            v-model="baja.tipo_baja_imss_id"
                                                            :error-messages="errors" 
                                                            required
                                                        ></v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pa-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Motivo de la baja" rules="required">
                                                        <v-textarea
                                                            outlined
                                                            class="estiloLetras"
                                                            v-model="baja.motivo"
                                                            label="Motivo de la baja"
                                                            outline
                                                            :error-messages="errors" 
                                                            required
                                                        ></v-textarea>
                                                    </ValidationProvider>
                                                </v-col>
                                        </template>
                                        <template v-if="accion === 'checadores'">
                                            <!-- CHECADORES -->

                                            <simple-table
                                                :classes="tableClasses"
                                                :rows="checadores"
                                                :columns="headersChecadores"
                                                :perPage="[1000]"
                                                shortPagination
                                                :showPagination="false"
                                                :emptyTable="'emptyTableWhite'"
                                                class="mt-6 "
                                            >
                                                <tbody slot="body" slot-scope="{ data }">
                                                    <template  v-for="item in data">
                                                        <tr :key="item.id">
                                                            <td style="background-color: #ffffff !important;" class="trChecadores">
                                                                <!-- <div class="tblPrincipal pl-5" style="background-color: #ffffff !important;">{{ item.descripcion }}</div>
                                                                <div class="tblSecundario pl-5">{{ item.ubicacion }}</div> -->
                                                                <h3 class="nombreChecador pl-14">{{ item.descripcion }}</h3>
                                                                <h4 class="ubicacionChecador pl-14">{{ item.ubicacion }}</h4>
                                                            </td>
                                                            <td style="background-color: #ffffff !important;" class="trChecadores">
                                                                <div class="tblOpcionesBtn">
                                                                    <v-tooltip bottom>
                                                                        <v-btn
                                                                            slot="activator"
                                                                            class="botonHover"
                                                                            icon
                                                                            fab
                                                                            dark
                                                                            small
                                                                            @click="eliminar_checador(item)"
                                                                        >
                                                                            <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                                        </v-btn>
                                                                        <span>Eliminar</span>
                                                                    </v-tooltip>
                                                                </div>
                                                                
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    
                                                </tbody>
                                            </simple-table>
                                            <!-- FIN CHECADORES -->
                                        </template>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions v-show="finaliza_carga" class="d-flex card_accion">
                                            <div class="">
                                                <button
                                                    class="button-default"
                                                    @click="storeDraft()"
                                                    v-if="accion === 'add' || accion === 'update'"
                                                >
                                                    Guardar borrador
                                                </button>
                                            </div>
                                            <v-row class="justify-end pr-3">
                                                <button
                                                    class="btnCerrar"
                                                    @click="cerrarModal()"
                                                    :loading="loading_guardar"
                                                    v-if="accion != 'checadores'"
                                                >
                                                    Cancelar
                                                </button>
                                                <button
                                                    class="btnCerrar"
                                                    @click="cerrarModal()"
                                                    :loading="loading_guardar"
                                                    v-if="accion == 'checadores'"
                                                >
                                                    Cerrar
                                                </button>
                                                <template v-if="(permisos.update) || (permisos.create && permisos.update == false && accion == 'add')">
                                                    <v-btn
                                                        class="btnGuardar"
                                                        @click="guardar()"
                                                        :loading="loading_guardar"
                                                        v-if="accion === 'add' || accion === 'update'"
                                                    >
                                                        Guardar
                                                    </v-btn>
                                                </template>
                                                <v-btn
                                                    class="btnGuardar"
                                                    @click="bajaEmpleado()"
                                                    :loading="loading_guardar"
                                                    v-if="accion === 'baja'"
                                                >
                                                    Baja
                                                </v-btn>
                                            
                                            </v-row>
                                </v-card-actions>

                                <div class="px-15 pb-10" v-if="permisos.update == false && accion == 'update'">
                                    <v-alert
                                        dense
                                        outlined
                                        type="error"
                                    >
                                        El usuario no tiene permiso para editar el registro.
                                    </v-alert>
                                </div>
                            </ValidationObserver>
                        </v-card>
                    </perfect-scrollbar>
                </v-dialog>
            </v-layout>
        </template>
        <template>
            <v-dialog v-model="dialogLayout" persistent max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" style="display: none;" class="botonModal" id="btnModalLayout"></v-btn>
                </template>
                <v-card>
                    <ValidationObserver ref="form2" v-slot="{ invalid }">
                        <v-card-title class="card_titulo padding_izquierdo padding_derecho padding_abajo">
                            <div class="headerModalStart">
                                <h2 class="titleModal_700_18">{{ titulo_modal_doc }}</h2>
                            </div>
                        </v-card-title>
                        <v-card-text class="card_texto">
                            <div id="padre" v-show="isLoading">
                                <div id="loading">
                                    <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                </div>
                            </div>
                            
                            <v-container v-show="!isLoading" grid-list-md id="contenedor">
                                <v-row class="pt-3">
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                        <ValidationProvider v-slot="{ errors }" name="Layout" rules="required">
                                            <v-file-input
                                                outlined
                                                label="Seleccionar el documento"
                                                v-model="archivo.archivo"
                                                accept=".xlsx"
                                                required 
                                                :error-messages="errors"
                                                prepend-icon=""
                                                append-icon="attach_file"
                                                id="fileDocument"
                                                @click:append="open"
                                            >
                                            </v-file-input>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button class="btnCerrar" @click="cerrarModal()" :disabled="isSaving">Cerrar</button>  
                            <v-btn class="btnGuardar" v-if="accionLayout === 'importar'" @click="guardarLayout2()" :disabled="invalid" :loading="isSaving">Subir</v-btn>
                            <v-btn class="btnGuardar" v-if="accionLayout === 'actulizacionMasivo'" @click="actulizacionMasivo()" :disabled="invalid" :loading="isSaving">Actualizar</v-btn>
                        </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>


        <template>
            <v-dialog v-model="dialogLayoutEmpleados" persistent max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" style="display: none;" class="botonModal" id="btnModalLayoutEmpleados"></v-btn>
                </template>
                <v-card>
                    <ValidationObserver ref="form2" v-slot="{ invalid }">
                        <v-card-title class="card_titulo padding_izquierdo padding_derecho padding_abajo">
                            <div class="headerModalStart">
                                <h2 class="titleModal_700_18">{{ tituloLayoutEmpleados }}</h2>
                            </div>
                        </v-card-title>
                        <v-card-text class="card_texto">
                            <div id="padre" v-show="isLoading">
                                <div id="loading">
                                    <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                </div>
                            </div>
                            
                            <v-container v-show="!isLoading" grid-list-md id="contenedor">
                                <v-row class="pt-3">
                                    <v-col v-if="rol == 'root'" cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                        <ValidationProvider v-slot="{ errors }" name="Cliente" rules="required">
                                            <v-autocomplete
                                                outlined
                                                label="Cliente"
                                                :items="clientes"
                                                item-text="nombre"
                                                item-value="id"
                                                persistent-hint
                                                v-model="cliente_value"
                                                required
                                                :error-messages="errors" 
                                            >
                                            </v-autocomplete>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col v-if="rol == 'root' || rol == 'admin'" cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                        <ValidationProvider v-slot="{ errors }" name="Empresa" rules="required">
                                            <v-autocomplete
                                                outlined
                                                label="Empresa"
                                                :items="empresas"
                                                item-text="nombre"
                                                item-value="id"
                                                persistent-hint
                                                v-model="empresa_value"
                                                required 
                                                :error-messages="errors" 
                                            >
                                            </v-autocomplete>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col v-if="accionLayout === 'subir' || accionLayout === 'actulizacionMasivo'" cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                        <ValidationProvider v-slot="{ errors }" name="Layout" rules="required">
                                            <v-file-input
                                                outlined
                                                label="Seleccionar el documento"
                                                v-model="archivo.archivo"
                                                accept=".xlsx"
                                                required 
                                                :error-messages="errors"
                                                prepend-icon=""
                                                append-icon="attach_file"
                                                id="fileDocument"
                                                @click:append="open"
                                            >
                                            </v-file-input>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button class="btnCerrar" @click="cerrarModal()" :disabled="isSaving">Cerrar</button>
                            <v-btn class="btnGuardar" v-if="accionLayout === 'subir'" @click="guardarLayout2()" :disabled="invalid" :loading="isSaving">Subir</v-btn>
                            <v-btn class="btnGuardar" v-if="accionLayout === 'descargar'" @click="layout2()" :disabled="invalid" :loading="isSaving">Descargar</v-btn>
                            <v-btn class="btnGuardar" v-if="accionLayout === 'exportar'" @click="exportar()" :disabled="invalid" :loading="isSaving">Exportar</v-btn>
                            <v-btn class="btnGuardar" v-if="accionLayout === 'actulizacionMasivo'" @click="actulizacionMasivo()" :disabled="invalid" :loading="isSaving">Actualizar</v-btn>
                        </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>

        <template>
            <v-layout row justify-center>
                <v-dialog v-model="dialogFoto" persistent max-width="450px">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" style="display: none;" class="botonModal" id="btnModalFoto"></v-btn>
                    </template>
                    <v-card>
                        <div>
                            <v-btn
                                @click="cerrarModalFoto()"
                                small
                                slot="activator"
                                icon
                                text
                                class="v-btn-cerrar pull-right mr-3 mt-3"
                            >
                                <v-icon class="icono-cerrar"></v-icon>
                            </v-btn>
                        </div>
                        <v-card-title>
                            <img src="/static/icon/webcam.png" class="imgChecador" />
                            <h3 class="tituloChecador">Tomar foto</h3>
                        </v-card-title>
                        <v-card-text>
                            <template style="paddin-left:30%">
                                <v-autocomplete
                                    :items="devices"
                                    item-text="label"
                                    item-value="deviceId"
                                    class="estiloFoto py-0 my-0"
                                    label="Webcam"
                                    persistent-hint
                                    v-model="camera"
                                >
                                    <template class="pa-0 ma-0" slot="prepend-inner">
                                        <v-icon class="tamIcono invertirColor">camera_alt</v-icon>
                                        <v-icon class="fa-rotate-270 pt-3 iconoDelgado">maximize</v-icon>
                                    </template>
                                </v-autocomplete>
                            </template>

                            <template v-if="imgFoto == null">
                                <div
                                    class="center el-video"
                                    style="position: relative; height: 250px; display: flex; align-items: center; padding: 0px 65px;"
                                >
                                    <web-cam
                                        id="video"
                                        ref="webcam"
                                        height="200"
                                        width="250"
                                        class="webcam"
                                        :device-id="deviceId"
                                        @started="onStarted"
                                        @stopped="onStopped"
                                        @error="onError"
                                        @cameras="onCameras"
                                        @camera-change="onCameraChange"
                                    />
                                </div>
                            </template>
                            <template v-else>
                                <v-flex
                                    class="center"
                                    style="position: relative; height: 200px; display: flex; align-items: center; padding: 0px 65px;"
                                >
                                    <img :src="imgFoto" style="height :200px; width: 250px" class="webcam img-responsive"/>
                                </v-flex>
                            </template>
                            <div class="col-md-12 btn-contenedor">
                                <v-btn v-if="imgFoto == null" class="btn-capturar" @click="onCapture">Capturar</v-btn>
                                <div v-else class="col-md-12 btn-contenedor">
                                    <v-btn class="btn-capturar" @click="guardaFoto">Guardar</v-btn>
                                    <v-btn class="btn-omitir" id="no-background-hover" @click="omitirFoto()">Tomar nueva foto</v-btn>
                                </div>
                            </div>
                        </v-card-text>
                        <v-card-actions>

                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </template>

        <template> <!-- Templete puesto, empresa, sucursal, depto, horario -->
            <v-row class="justify-center">
                <v-dialog v-model="dialog_agregar" persistent max-width="600px" scrollable>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal_agregar"></v-btn>
                    </template>
                    <perfect-scrollbar style="background:#FFF">
                        <v-card elevation="0">
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <img :src="imgModalAgregar" class="imgModal" />
                                    <h2 class="titleModal">{{ titulo_modal_agregar }}</h2>
                                </div>
                            </v-card-title>
                            <v-card-text class="card_texto">
                                <div id="padre" v-show="!finaliza_carga_agregar">
                                    <div id="loading">
                                        <v-progress-circular
                                            indeterminate
                                            :size="100"
                                            :width="7"
                                            color="blue"
                                        ></v-progress-circular>
                                    </div>
                                </div>
                                <v-container v-show="finaliza_carga_agregar" grid-list-md id="contenedor">
                                    <v-divider class="divider"></v-divider>           
                                    <pop-puesto
                                        v-if="tPuesto && !tEmpresa && !tSucursal && !tDeptos && !tReloj"
                                        :oyente="valor"
                                        :reset="resetValuesAgregar"
                                        @save="guardarAgregar"
                                        :key="componentKey"
                                        @resetValorGuardar="resetValorGuardar"
                                    ></pop-puesto>
                                    <pop-empresa
                                        v-if="!tPuesto && tEmpresa && !tSucursal && !tDeptos && !tReloj"
                                        :oyente="valor"
                                        :reset="resetValuesAgregar"
                                        @save="guardarAgregar"
                                        :key="componentKey"
                                        @resetValorGuardar="resetValorGuardar"
                                    ></pop-empresa>
                                    <pop-sucursal
                                        v-if="!tPuesto && !tEmpresa && tSucursal && !tDeptos && !tReloj"
                                        :oyente="valor"
                                        :reset="resetValuesAgregar"
                                        @save="guardarAgregar"
                                        :key="componentKey"
                                        @resetValorGuardar="resetValorGuardar"
                                        @oyenteFalse="oyenteFalse"
                                    ></pop-sucursal>

                                    <pop-departamento
                                        v-if="!tPuesto && !tEmpresa && !tSucursal && tDeptos && !tReloj"
                                        :oyente="valor"
                                        :reset="resetValuesAgregar"
                                        @save="guardarAgregar"
                                        :key="componentKey"
                                        @resetValorGuardar="resetValorGuardar"
                                    ></pop-departamento>
                                    
                                    <pop-horario
                                        v-if="!tPuesto && !tEmpresa && !tSucursal && !tDeptos && tReloj"
                                        :oyente="valor"
                                        :reset="resetValuesAgregar"
                                        @save="guardarAgregar"
                                        :key="componentKey"
                                        @resetValorGuardar="resetValorGuardar"
                                    ></pop-horario>
                                </v-container>
                            </v-card-text>

                            <v-card-actions class="d-flex justify-end card_accion">
                                <button
                                    class="btnCerrar pull-right"
                                    @click="cerrarModalAgregar()"
                                    :loading="loading_guardar_agregar"
                                >
                                    Cancelar
                                </button>
                                <v-btn
                                    class="btnGuardar pull-right"
                                    @click="obtener()"
                                    :loading="loading_guardar_agregar"
                                >
                                    Guardar
                                </v-btn>         
                            </v-card-actions>
                        </v-card>
                    </perfect-scrollbar>
                </v-dialog>
            </v-row>
        </template><!-- Fin Templete puesto, empresa, sucursal, depto, horario -->
        <template class="borde-card">
                <v-dialog v-model="dialogRenovar" persistent max-width="500px" class="borde-card">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModalTimbre"></v-btn>
                    </template>
                    <v-card class="borde-card">
                            <v-card-title class="justify-center align-center text-center card_titulo">
                                <div>
                                    <img src="/static/icon/alert_warning.png" class="imgModal pb-5" />
                                    <h2 class="titleModalTimbre pb-5">Hubo un cambio en el empleado<br>que afecta el contrato</h2>
                                    <!-- <template v-if="renovarRegenerar">
                                        <h2 class="titleModalTimbre pb-5">Hubo un cambio en el <br>contrato de este empleado</h2>
                                    </template>
                                    <template v-else>
                                        <h2 class="titleModalTimbre pb-5">Hubo un cambio en el <br>contrato de este empleado</h2>
                                    </template>  -->
                                </div>
                            </v-card-title>

                            <v-card-text class="card_texto">
                                <v-container  grid-list-md id="contenedor">
                                    <v-col cols="12" xs="12" sm="12" md="12" class="px-0 justify-center align-center text-center textTimbre">
                                        Se cancelará el contrato actual y se hará una copia del mismo con los nuevos datos
                                       <!--  {{renovarRegenerar ? "Puede Regenerar el contrato (se cancelara el contrato actual y se hara una copia del mismo con los nuevos datos) o Renovar el contrato (quedara vencido en contrato y se creara uno nuevo con la información nueva).":"El contrato actual quedara vencido en contrato y se creara uno nuevo con la información nueva."}} -->
                                    </v-col>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="card_accion pt-0">
                                <v-container  grid-list-md class="ma-0 pa-0">
                                    <v-col v-if="renovarRegenerar" cols="12" xs="12" sm="12" md="12" class="px-0 pb-2 pt-0 justify-center align-center text-center">
                                        <v-btn 
                                            class="btnModalAlert"
                                            color='rgb(212, 16, 16)'
                                            dark
                                            @click="regenerarContrato()"
                                        >
                                            Regenerar
                                        </v-btn>
                                    </v-col>
                                    <!-- <v-col cols="12" xs="12" sm="12" md="12" class="px-0 py-2 justify-center align-center text-center">
                                        <v-btn 
                                            class="btnModalAlert"
                                            color='rgb(212, 16, 16)'
                                            dark
                                            @click="renovarContrato()"
                                        >
                                            Renovar
                                        </v-btn>
                                    </v-col> -->
                                    <v-col cols="12" xs="12" sm="12" md="12" class="px-0 pt-2 pb-0 justify-center align-center text-center">
                                        <v-btn 
                                            class="btnModalAlert"
                                            color='#828282'
                                            @click="guardarValido()"
                                            text
                                        >
                                            Continuar sin regenerar
                                        </v-btn>
                                    </v-col>
                                </v-container>
                            </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <template class="borde-card">
                <v-dialog v-model="dialogErrores" persistent max-width="950px" class="borde-card">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModalErrores"></v-btn>
                    </template>
                    <v-card class="borde-card">
                        <v-card-title class="padding_izquierdo padding_derecho padding_arriba">
                                <v-btn
                                    @click="cerrarModalErrores()"
                                    small
                                    slot="activator"
                                    icon
                                    text
                                    class="v-btn-cerrar modal-pull-right"
                                    absolute
                                    top
                                    right
                                >
                                    <v-icon class="icono-cerrar"></v-icon>
                                </v-btn>
                            <div class="headerModalStart">
                                <h2 class="titleModalErrores">Errores de empleados</h2>
                            </div>
                        </v-card-title>

                        <v-card-text class="padding_izquierdo padding_derecho padding_abajo">
                            <div id="padre" v-show="isLoadingError">
                                <div id="loading">
                                    <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                </div>
                            </div>
                            
                            <v-container v-show="!isLoadingError" grid-list-md id="contenedor">
                                <v-row class="pa-0 ma-0">
                                    <v-col cols="12" xs="12" sm="12" md="12" class="pa-0 ma-0">
                                        <table class="tbl-errores">
                                            <thead class="tbl-header">
                                                <tr>
                                                    <th style="border-top-left-radius: 20px;" class="pl-7 errorth">Empleado</th>
                                                    <th style="border-top-right-radius: 20px;" class="errorth">Tipo de error</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="erroresModal.length == 0" >
                                                    <td class="emptyTableErrores" colspan="2">
                                                        No hay elementos para mostrar
                                                    </td>
                                                </tr>
                                                <template v-else v-for="(error, index) in erroresModal">
                                                    <template>
                                                        <tr :key="index">
                                                            <td class="pl-7 errortd pt-4 pb-0">
                                                                <div class="textoTablaError01">{{error.nombre_s + ' ' + error.apellido_paterno + ' ' + error.apellido_materno}}</div>
                                                            </td>
                                                            <td class="errortd"> <div class="textoTablaError03">{{error.observaciones}}</div> </td>
                                                        </tr>
                                                        <tr :key="'A'+index" class="trDivider"><div class="my-2"></div></tr>
                                                    </template>
                                                </template>
                                            </tbody>
                                        </table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </template>

            <v-dialog v-model="dialogSueldo" persistent max-width="800px" class="borde-card">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModalSueldo"></v-btn>
                </template>
                <v-card class="borde-card">
                    <ValidationObserver ref="formSueldo" v-slot="{ invalid }">
                        <div xs="1" sm="1" md="1" lg="1" class="v-btn-alineacion background-transparent mt-2" style="float: right;">
                            <v-btn
                                @click="cerrarModalSueldo()"
                                small
                                icon
                                text
                                :ripple="false" 
                                class="v-btn-cerrar mr-2"
                            >
                                <v-icon class="icono-cerrar"></v-icon>
                            </v-btn>
                        </div>
                        <v-card-title class="card_titulo padding_izquierdo padding_derecho">
                            <div class="headerModalStart">
                                <h2 class="titleModal_700_18">Modificar salario individual actual</h2>
                            </div>
                        </v-card-title>
                        <v-card-text class="card_texto mt-0">
                            <div id="padre" v-show="isLoadingModalSueldo"> 
                                <div id="loading" class="d-flex justify-center my-10">
                                    <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                </div>
                            </div>

                            <v-container v-show="!isLoadingModalSueldo" grid-list-md id="contenedor">
                                <v-row class="mt-0 mb-5">
                                    <v-col cols=12 xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                        <v-divider class="py-0 my-6"></v-divider>
                                    </v-col>
                                    <v-col
                                        cols="12" xs="12" sm="12" md="12" lg="12" xl="12" 
                                        class="pa-0" 
                                    >
                                        <ValidationObserver ref="formIncremento" v-slot="{ invalid }">
                                            <v-row class="pa-0 ma-0">
                                                <v-col
                                                    cols="12" xs="12" sm="12" md="12" lg="12" xl="12" 
                                                    class="py-0" 
                                                >
                                                    <v-text-field
                                                        outlined
                                                        label="Empleado"
                                                        class="pa-0 ma-0"
                                                        disabled
                                                        v-model="nombre_completo_sueldo" 
                                                    />
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0 ma-0">
                                                    <VuetifyDatePicker
                                                        outlined
                                                        rules="required"
                                                        :valorDefecto="colaborador.fecha_de_aplicacion"
                                                        v-model="colaborador.fecha_de_aplicacion"
                                                        label="Fecha de aplicación"
                                                        placeholder="dd/mm/aaaa"
                                                        ref="FechaAplicacion"
                                                    />
                                                </v-col>

                                                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0 ma-0">
                                                    <VuetifyMoneyValidate
                                                        outlined
                                                        label="Sueldo diario"
                                                        class="pa-0 ma-0"
                                                        prefix="$"
                                                        rules="required"
                                                        v-model="colaborador.valor"
                                                        v-bind:options="options"
                                                    >
                                                        
                                                    </VuetifyMoneyValidate>
                                                </v-col>
                                                

                                                <v-col cols="12" xs="12" sm="12" md="12" class="pt-0 pb-0 ma-0 d-flex justify-end">
                                                    <button
                                                        v-if="guardarEdicionSueldo == 'edicion'"
                                                        class="btnCerrar"
                                                        @click="cancelarEdicion()" 
                                                        :disabled="isSavingSueldo"
                                                    >
                                                        Cancelar
                                                    </button>
                                                    <v-btn
                                                        class="btnGuardar"
                                                        @click="guardarEdicionSueldo == 'guardar' ? guardarSueldo():guardarEdicion()" 
                                                        :disabled="invalid" 
                                                        :loading="isSavingSueldo"
                                                    >
                                                        Guardar
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </ValidationObserver>
                                    </v-col>

                                    

                                    <v-col 
                                        cols="12" xs="12" sm="12" md="12" lg="12" xl="12" 
                                        class="py-0 mt-5" 
                                        style="min-height:10rem;"
                                        
                                    >
                                        <div class="headerModalStart mt-5">
                                            <h2 class="titleModal_700_18">Historial de modificaciones del salario</h2>
                                        </div>
                                        <v-col cols=12 xs="12" sm="12" md="12" lg="12" xl="12" class="pa-0">
                                            <v-divider class="py-0 mt-6 mb-3"></v-divider>
                                        </v-col>
                                            
                                        <div style="overflow-x: auto;" class="pb-5">
                                            <table class="tbl-salario" >
                                                <thead class="tbl-header">
                                                    <tr>
                                                        <th class="th-tabla pl-7 firstth">Fecha de aplicación</th>
                                                        <th class="th-tabla thTitulos px-4">Fecha de modificación</th>
                                                        <th class="th-tabla thTitulos pl-4" style="text-align: right !important;">Sueldo</th>
                                                        <th class="th-tabla lastth thTitulos pl-0 pr-4"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="datosTabla.length == 0" >
                                                        <td class="emptyTableSueldo" colspan="3">
                                                            No hay elementos para mostrar
                                                        </td>
                                                    </tr>
                                                    <template v-else>
                                                        <template  v-for="(sueldo, index) in datosTabla" >
                                                            <tr class="trBody">
                                                                <td class="pl-8">
                                                                    {{dateFormat(sueldo.fecha_de_aplicacion)}}
                                                                </td>
                                                                <td class="pl-4">
                                                                    {{dateFormat(sueldo.updated_at.substr(0,10))}}
                                                                </td>
                                                                <td class="pl-4" style="text-align: right !important;">
                                                                    ${{sueldo.nuevo_sueldo}}
                                                                </td>
                                                                
                                                                <!-- <td class="px-0">
                                                                    <v-btn
                                                                        v-if="index == 0"
                                                                        class="elevation-0 ma-0 pa-0 v-btn-hover"
                                                                        color="transparent"
                                                                        @click="editarModalSueldo-----(sueldo)"
                                                                        rounded
                                                                        :ripple="false" 
                                                                    >
                                                                        <v-icon color="white" class="tamIconoBoton invertirColorBotones">
                                                                            edit
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </td> -->
                                                            </tr>
                                                        </template>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    
                    </ValidationObserver>
                </v-card>
            </v-dialog>

        <template>
            <v-dialog v-model="dialogClave" persistent max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" style="display: none;" class="botonModal" id="btnModalLayout"></v-btn>
                </template>
                <v-card>
                    <v-card-title class="card_titulo padding_izquierdo padding_derecho">
                        <div class="headerModalStart">
                            <h2 class="titleModal_700_18">Clave checador</h2>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <div id="padre" v-show="isLoadingChecador">
                            <div id="loading">
                                <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                            </div>
                        </div>
                        
                        <v-container v-show="!isLoadingChecador" grid-list-md id="contenedor">
                            <v-divider class="divider"></v-divider>
                            <v-row>
                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                    <table class="ml-3">
                                        <tr>
                                            <td class="textoTablaClave01">
                                                Clave del empleado: 
                                            </td>
                                            <td class="textoTablaClave02">
                                                {{claveEmpleado.clave}}
                                            </td>
                                            <td>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="textoTablaClave01">
                                                Clave de seguridad: 
                                            </td>
                                            <td class="textoTablaClave02">
                                                {{claveEmpleado.claveVerificacion? claveEmpleado.claveVerificacion:'----'}}
                                            </td>
                                            <td>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" class="botonHover" icon fab dark small @click="generarClave()">
                                                        <v-icon class="tamIconoBoton iconoDelgadoBoton">autorenew</v-icon>
                                                    </v-btn>
                                                    </template>
                                                    <span>Generar</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                    </table>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end card_accion">
                        <button class="btnCerrar" @click="cerrarModalClave()">Cerrar</button>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
        <!--MODAL COLONIA FORM-->
        <template class="borde-card">
            <v-dialog v-model="dialogColonia" persistent max-width="500px" class="borde-card">
                <v-card class="borde-card">
                    <ValidationObserver ref="formColonia" v-slot="{invalid}">

                            <v-card-title class="card_titulo padding_izquierdo padding_derecho">
                                <div class="headerModalStart">
                                    <h2 class="titleModal_700_18">Agregar colonia</h2>
                            </div>
                        </v-card-title>
                        <v-card-text class="card_texto mt-5">
                            <div id="padre" v-show="isLoadingModalColonia">
                                <div id="loading">
                                    <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                </div>
                            </div>
                            <v-container v-show="!isLoadingModalColonia" grid-list-md id="contenedor">
                                <v-row class="mt-0">
                                    <v-col cols="12" xs="12" sm="12" md="12" class="pt-0 pb-0 ma-0">
                                        <ValidationProvider v-slot="{ errors }" name="Código postal" rules="required">
                                            <v-text-field 
                                                outlined
                                                label="Código postal" 
                                                class="pa-0 ma-0" 
                                                v-model="busca_cp" 
                                                :error-messages="errors" 
                                                required
                                                disabled
                                            >
                                            </v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="12" class="pt-0 pb-0 ma-0">
                                        <ValidationProvider v-slot="{ errors }" name="Colonia" rules="required">
                                            <v-text-field 
                                                outlined
                                                label="Colonia" 
                                                class="pa-0 ma-0" 
                                                v-model="nombreColonia" 
                                                :error-messages="errors" 
                                                required
                                            >
                                            </v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button
                                class="btnCerrar"
                                @click="cerrarModalColonia()"
                                :disabled="isSavingColonia">
                                Cancelar
                            </button>
                            <v-btn
                                class="btnGuardar"
                                @click="guardarColonia()"
                                :disabled="invalid"
                                :loading="isSavingColonia">
                                Guardar
                            </v-btn>
                        </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import Notify from "@/plugins/notify";
import Swal from "sweetalert2";
import Datatable from "@/components/datatable/Datatable.vue";
import Star from "@/components/rating/Star.vue";
import cognitiveServicesApi from "../api/cognitiveServices";
import empleadosApi from "../api/empleados";
import catalogoApis from "../api/catalogos";
import clientesApi from "../api/clientes";
import empresaApi from "../api/empresas";
import sucursalApi from "../api/sucursales";
import departamentoApi from "../api/departamentos";
import horariosApi from "../api/horarios";
import prestacionApi from "../api/prestaciones";
import relojApi from "../api/dispositivos";
import estadosCivilesApi from "../api/estadosCiviles";
import estadosCiviles from "../api/estadosCiviles";
import dispositivosApi from "../api/dispositivos";
import GetUrlImg from "@/plugins/Urlimagen";
import io from "socket.io-client";
import PerfectScrollbar from "perfect-scrollbar";
import puestoApi from "../api/puestos";
import { WebCam } from "vue-web-cam";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import PopPuesto from "@/components/PopPuesto.vue";
import PopEmpresa from "@/components/PopEmpresa2.vue";
import PopSucursal from "@/components/PopSucursal3.vue";
import PopDepartamento from "@/components/PopDepartamento2.vue";
import PopHorario from "@/components/PopHorario.vue";
import apiTipoContratoSAT from '@/api/tipoContrato';
import apiContrato from '@/api/contratos';
import apiTipoBajaImss from "@/api/tipoBajaImss";
import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';
import env from "@/plugins/enviroment";
import SimpleDatatable from "@/components/simpletable/Datatable.vue";
import apiBrigadas from "@/api/brigadas";
import apiCapacitaciones from "@/api/cursoCapacitacion";
import VuetifyMoneyValidate from '@/components/VuetifyMoneyValidate.vue';
import apiPeriodicidad from '@/api/periodicidadPago';
import apiTipoRegimen from "@/api/tipoRegimen";
import categoriaEmpleadoApi from "@/api/categoriaEmpleado";
import apiIncrementoSalarial from '@/api/incrementoSalario';
import apiRelojChecador from '@/api/registros';
import axios from "axios";
import Echo from "laravel-echo";
window.Pusher = require('pusher-js');

export default {
    name: "Empleados",
    components: {
        "data-table": Datatable,
        "simple-table": SimpleDatatable,
        "rating-star": Star,
        "web-cam": WebCam,
        "pop-puesto": PopPuesto,
        "pop-empresa": PopEmpresa,
        "pop-sucursal": PopSucursal,
        "pop-departamento": PopDepartamento,
        "pop-horario": PopHorario,
        VuetifyDatePicker,
        VuetifyMoneyValidate,
    },
    data() {
        return {
            dialogRenovar : false,
            renovarRegenerar : false,
            empresaVal : null,
            url: "empleados/find",
            columns: [
                {
                    label: "Clave",
                    name: "clave",
                    filterable: true
                },
                {
                    label: "Nombre",
                    name: "nombre",
                    filterable: true
                },
                {
                    label: "Antigüedad",
                    name: "antiguedad",
                    filterable: true,
                },
                {
                    label: "Ranking",
                    name: "ranking",
                    filterable: true,
                    align: 'center'
                },
                {
                    label: "Opciones",
                    name: "opciones",
                    filterable: false,
                    align: 'center'
                }
            ],
            filters: {
                rol_name        : null,
                usuario_id      : null,
                activo          : true,
                paginate        : true,
                include_padres  : true,
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                departamento_id : null,
                categoria_id    : null,
                order_by        : 'clave',
            },
            advancedSearch: {
                nombre          : null,
                direccion       : null,
                codigo_postal   : null,
                empresa_id      : null,
                estado_id       : null,
                cliente_id      : null,
                empleado_correo : null
            },
            urlChecadores       : "reloj-checador/find",
            socket              : {},
            urlImg              : null,
            filtrosChecador     : {},
            loading_guardar     : false,
            loading_checador    : false,
            loading             : true,
            dialog              : false,
            dialogLayout        : false,
            dialogBusqueda      : false,
            search              : "",
            calendar            : false,
            ingreso             : false,
            baja                : false,
            //dosContratos        : false,
            complex             : {
                selected    : [],
                headers     : [
                    { text: "Nombre Completo", value: "nombre_completo" },
                    { text: "Antigüedad", value: "dia_descanso" },
                    { text: "Ranking", value: "" },
                    { text: "Opciones", value: "" }
                ],
                items       : []
            },
            checador            : {
                headers     : [
                    { text: "Nombre", value: "descripcion", class: "cabecera-tabla" },
                    { text: "Opciones", value: "opciones", class: "cabecera-tabla" }
                ],
                items       : []
            },
            empleado: {
                id                  : 0,
                nombre              : null,
                apellido_paterno    : null,
                apellido_materno    : null,
                fecha_nacimiento    : null,
                nacionalidad        : null,
                sexo                : "M",
                direccion           : null,
                estado_id           : null,
                codigo_postal       : null,
                telefono            : "",
                correo              : null,
                estado_civil_id     : 1,
                fecha_ingreso       : null,
                fecha_baja          : "",
                dia_descanso        : "0",
                cliente_id          : null,
                empresa_id          : null,
                sucursal_id         : null,
                departamento_id     : null,
                horario_id          : null,
                prestacion_id       : null,
                tipo_contrato_id    : null,
                tiene_hijos         : false,
                puesto              : null,
                clave_interna       : null,
                email_anterior      : null,
                dias_vacaciones     : null,
                foto                : null,
                foto_default        : null,
                puesto_id           : null,
                nivel_estudios_id   : null,
                cp_id               : null,
                municipio_id        : null,
                colonia_id          : null,
                mejora_continua     : false,
                ambiente_laboral    : true,
                brigada_proteccion_civil_id : null,
                cursos_capacitaciones : [],
                salario_diario      : null,
                periodicidad_id     : null,
                tipo_regimen_sat_id : null,
                rfc                 : null,
                curp                : null,
                dias_contrato       : 30,
                direccion_contrato      : null,
                //segundo_contrato_tipo_contrato_id : null,
                empleado_categoria_id: null,
            },
            contratoEmpleado : {
                empleado_id : null,
                tipo_contrato_id : null,
                dias_contrato : null,
                fecha_ingreso : null,
            },
            accion                  : "",
            titulo_modal            : "",
            finaliza_carga          : false,
            parametros_base         : { activo: true, paginate: false, order: "asc" },
            datosLogin              : "",
            ciudades                : [],
            estados                 : [],
            estado_id               : null,
            departamento_id         : "",
            clientes                : [],
            prestaciones            : [],
            empresas                : [],
            sucursales              : [],
            departamentos           : [],
            horarios                : [],
            cliente_value           : null,
            empresa_value           : null,
            sucursal_value          : null,
            departamento_value      : null,
            sucursal_id             : "",
            rol                     : "",
            nombre_completo         : "",
            nombre_completo_empleados: [],
            nombre_completo_correo  : null,
            conteo_parametros       : 0,
            estados_civiles         : [],
            empleado_checador_id    : 0,
            url_checador            : "",
            token_checador          : "",
            nombre_archivo          : "",
            archivo                 : {
                archivo     : null,
                cliente_id  : null,
                empresa_id  : null,
                sucursal_id : null,
                rol_name    : null,
            },
            empleado_ar             : null,
            imageUrl                : "",
            menu_inicio             : false,
            menu_final              : false,
            fecha_inicio            : null,
            fecha_final             : null,
            menu_inicio_c           : false,
            menu_final_c            : false,
            fecha_inicio_c          : null,
            fecha_final_c           : null,
            nombreImagen            : "",
            archivoImagen           : null,
            tamModal                : "900px",
            calendarBaja            : false,
            baja                    : {
                id                  : null,
                rol_name            : null,
                accion              : "Baja",
                motivo              : "",
                fecha               : "",
                usuario_id          : null,
                email               : "",
                tipo_baja_imss_id   : null,
            },
            nombreBaja              : "",
            ImagenModal             : "/static/modal/empleadoCreate.svg",
            codigos_postales        : [],
            colonias                : [],
            estudios                : [],
            puestos                 : [],
            busca_cp                : "",
            estado                  : "",
            ciudad                  : "",
            dialogFoto              : false,
            camera                  : null,
            deviceId                : null,
            devices                 : [],
            imgFoto                 : null,
            isProcessFinished       : false,
            selectedOption          : null,
            showMenu                : false,
            archivo_adjunto         : "Subir archivo",
            loading_guardar_agregar : false,
            finaliza_carga_agregar  : false,
            dialog_agregar          : false,
            titulo_modal_agregar    : null,
            imgModalAgregar         :null,
            valor                   : false,
            resetValuesAgregar      :false,
            tPuesto                 : false,
            tEmpresa                : false,
            tSucursal               : false,
            tDeptos                 : false,
            tReloj                  : false,
            mPuesto                 : false,
            mEmpresa                : false,
            mSucursal               : false,
            mDeptos                 : false,
            mReloj                  : false,
            determinado             : false,
            contratos               : [],
            nombreFoto              : null,
            tipos_baja_imss         : [],
            updateEmpleado          : false,
            dialogLayoutEmpleados   : false,
            tituloLayoutEmpleados   : 'Descargar layout para agregar empleados',
            accionLayout            : 'descargar',
            archivoLayout           : [],
            isLoading               : false,
            isSaving                : false,  
            componentKey            : 0,
            itemsBrigadas           : [],
            itemsCursosCapacitaciones : [],
            modelCursosCapacitaciones   : [], 
            cursos_capacitaciones_eliminadas : [],
            curso_id                : null,
            evaluacion              : null,
            observaciones           : null,
            itemsCapacitaciones     : [],
            periodicidades          : [],

            headersChecadores: [
                { label: "Nombre", name: "nombre", filterable: false },
                { label: "Opciones", name: "opciones", filterable: false, align: 'center' },
            ],
            tableClasses: {
                table: {
                    "no-box-shadow":true
                },
                "t-head": {
                    "no-radius": true,
                    "titulo-first-child": true,
                },
            },
            messageFoto: null,
            itemsDiasContratos: [{dias:30}, {dias:60}, {dias:90},{dias: 180}],
            modelDiasContrato: 30,
            options: {
                locale: "es-MX",
                prefix: "$",
                suffix: "",
                length: 11,
                precision: 2
            },
            frase:'Descargando archivo',
            overlayDesgarga: false,
            correo_search: null,
            tiposRegimenesSAT   : [],
            desabilitarSueldo   : false,
            erroresModal        : [],
            dialogErrores       : false,
            isLoadingError      : false,


            dialogSueldo            : false,
            isLoadingModalSueldo    : false,
            isSavingSueldo          : false,
            datosTabla              : [],
            tipoSueldo              : null,
            guardarEdicionSueldo    : null,
            nombre_completo_sueldo  : '',
            colaborador             : {
                id                      : null,
                nombre_completo         : null,
                empleado_id             : null,
                salario_anterior        : null,
                sbc_anterior            : null,
                salario_nuevo           : null,
                sbc_nuevo               : null,
                fecha_de_aplicacion     : null,
                tipo                    : 'fijo',
                valor                   : null,
                salario_base_cotizacion : null,
                sbc_fijo                : null,
                sbc_variable            : null,
                nuevo_sbc_fijo          : null,
                nuevo_sbc_variable      : null,
                anterior_sbc_fijo       : null,
                anterior_sbc_variable   : null,
                fecha_de_aplicacion_anterior: null,
            },
            itemsTipoTrabajadorIMSS : [],
            itemsTipoSalarioIMSS    : [],
            itemsSemanaIMSS         : [],
            isLoadingSBC            : false,

             //variables para overlay de empleados
            empleadosPorcentaje     : 0,
            empleadosTotal          : 0,
            empleadosProcesados     : 0,
            procesados              : 0,
            conError                : 0,
            dialogMensaje           : false,
            dialogOverlayEmpleados  : false,

            claveEmpleado           : {
                clave: null,
                claveVerificacion: null,
            },
            dialogClave             : false,
            isLoadingChecador       : false,

            //Modal Colonia
            dialogColonia           : false,
            isLoadingModalColonia   : true,
            nombreColonia           : null,
            isSavingColonia         : false,
            mColonia                : false,

            categoriasEmpleado: [],
            categoria_empleado: null,
            id_anterior: null,
            id_nuevo: null,

            permisos :{
                create: false,
                update: false,
                delete: false,
            }

        };
    },
    computed: {
        ...mapState("auth", ["datos", "user"]),
        device: function() {
            return this.devices.find(n => n.deviceId === this.deviceId);
        },
        computedSistema: function(){
            if(this.$session.get("sistema") == 'gdth'){
                return true
            }
            else{
                return false
            }
            
        },

        computedPuestos: function(){
            if(this.puestos.length != 0){
                let format = this.puestos.map((val) => {
                    return {
                        ...val,
                        claveNombre: `${val.clave} - ${val.nombre}`
                    }
                })

                //console.log(format)

                return format
                
            }else{
                return []
            }
        },
       
    },
    watch: {
        cliente_value: function(val) {
            if(val != null && !this.updateEmpleado){
                this.cambiaCliente(val);
            }
        },
        empresa_value: function(val) {
            if(val != null && !this.updateEmpleado){
                this.cambiaEmpresa(val);
                this.getPrestaciones();
                this.getCapacitaciones();
                this.getContratosFormatos();
                if(val != null){
                    this.mSucursal = true;
                }
                else{
                    this.mSucursal = false;
                }
                
                let empresa = this.empresas.filter(el => el.id == val);
                //console.log(empresa[0].registro_patronal_id);
                //this.validarDosContratos(empresa[0].registro_patronal_id);
                
            }
           
        },
        sucursal_value: function(val) {
            if(val != null && !this.updateEmpleado){
                this.cambiaSucursal(val);
                this.mDeptos = true;
                this.mReloj =  true;
                this.mPuesto = true;
            }
            else{
                this.mDeptos = false;
                this.mReloj = false;
                this.mPuesto = false;
            }
        },
        busca_cp: function(val) {
            if (val.length == 5) {
                this.busca_codigos(val);
                this.mColonia = true;
            } else {
                this.estado = "";
                this.ciudad = "";
                this.colonias = [];
                this.mColonia = false;
            }
        },
        camera: function(id) {
            this.deviceId = id;
        },
        devices: function() {
            const [first, ...tail] = this.devices;
            if (first) {
                this.camera = first.deviceId;
                this.deviceId = first.deviceId;
            }
        },
        
        'empleado.tipo_contrato_id' : function(val, oldVal){
            if(val != null){
                let contrato = this.contratos.find(element => element.id == val);
                let clave = "";
                clave = contrato.tipo_contrato? contrato.tipo_contrato.clave : contrato.clave_formato;
                if(clave == "03"){
                    this.determinado = true;
                }else{
                    this.determinado = false;
                }

                if(this.id_anterior == null){
                    if(oldVal == null){
                        oldVal = val
                    }

                    this.id_anterior = oldVal
                }

                this.id_nuevo = val

            }
            
        },
        'empleado.direccion':function(val){
            this.formatoDireccionContrato();
        },
        'empleado.colonia_id':function(val){
            this.formatoDireccionContrato();
        },
        'estado':function(val){
            this.formatoDireccionContrato();
        },
        'ciudad':function(val){
            this.formatoDireccionContrato();
        },
    },
    methods: {
        ...mapActions("auth", ["notificacion"]),
        formatoDireccionContrato(){
            let colonia = this.colonias.find(element => element.id == this.empleado.colonia_id);
            let nombreColonia = "";
            if(colonia != undefined){
                nombreColonia = colonia.nombre!=undefined ? colonia.nombre : '';
            }
            if(this.accion == 'add'){
                this.empleado.direccion_contrato = (this.empleado.direccion + " DE LA COLONIA " + nombreColonia + " CÓDIGO POSTAL " + this.busca_cp + " " + this.ciudad  + ", " + this.estado).toUpperCase()
            }
        },
        toggleDropdown (event) {
            event.currentTarget.classList.toggle('is-active')
        },
        open(){
            //this.$refs.fileDocument.$el.querySelector('input').click()
            //this.$refs.fileDocument.click()
            document.getElementById("fileDocument").click();
        },
        async abrirModalLayoutEmpleados(accion){
            this.isLoading = true;
            this.accionLayout = accion;
            this.dialogLayoutEmpleados = true;
            if(accion === 'descargar' ){
                this.tituloLayoutEmpleados  = 'Descargar layout para agregar empleados';
            }
            else if (accion === 'subir'){
                this.tituloLayoutEmpleados  = 'Subir layout para agregar empleados';
            }
            else if (accion === 'exportar'){
                this.tituloLayoutEmpleados  = 'Exportar layout de empleados';
            }
            else if(accion === 'actulizacionMasivo'){
                this.tituloLayoutEmpleados = 'Actualización masiva';
            }
            if (this.rol == "admin") {
                this.archivo.cliente_id = this.datosLogin.cliente_id;
                this.cliente_value = this.datosLogin.cliente_id;
            }
            if(this.rol == "root"){
                this.getClientes();
            }
            this.isLoading = false;
        },
        async busca_codigos(cp) {
            let self = this;
            let params = {
                activo: true,
                nombre: cp,
                include_padres: true
            };
            await catalogoApis.getCP(params).then(response => {
                let result = response.data;
                if (result.length == 0) {
                    Notify.ErrorToast("No se encontro el Código postal.");
                    this.estado = "";
                    this.ciudad = "";
                    this.colonias = [];
                    this.mColonia = false;
                    return;
                }
                this.estado = result[0].nomb_estado;
                this.ciudad = result[0].nomb_mun;
                this.empleado.estado_id = result[0].estado_id;
                this.empleado.cp_id = result[0].id;
                this.empleado.municipio_id = result[0].municipio_id;

                catalogoApis.getColonias({ codigo_postal_id: result[0].id, order: "asc", paginate: false }).then(response => {
                    self.colonias = response.data;
                    if (self.accion == "update") {
                        self.finaliza_carga = true;
                        self.updateEmpleado = false;
                    }
                })
                .catch(e => {
                    Notify.ErrorToast("Se presento un problema al cargar las colonias.");
                    return;
                });
            })
            .catch(e => {
                console.log(e);
                Notify.ErrorToast("Ocurrió un error al cargar los estados y ciudades.");
            });
        },
        getCP(id) {
            catalogoApis.getCodigoPostal(id).then(response => {
                this.empleado.busca_cp = response.nombre;
                this.busca_cp = response.nombre;
                //this.busca_codigos();
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los códigos postales.");
            });
        },
        init() {
            const elementScroll = document.querySelector('#btnModal');
            if(elementScroll) {
                /*const ps = new PerfectScrollbar(elementScroll);
                */
                const ps = new PerfectScrollbar(elementScroll, {
                    wheelSpeed: 2,
                    wheelPropagation: true,
                    minScrollbarLength: 20
                });
            }
        },

        listar(parametros = null) {
            this.resetValue();
            let self = this;
            this.urlImg = GetUrlImg.getURL();
            this.datosLogin = this.$session.get("usuario");
            this.token_checador = localStorage.getItem("token_checador");
            this.rol = this.datosLogin.rol.name;
            this.cliente_id = this.$session.get("detalle_cliente_id");
            (this.filters.rol_name = this.datosLogin.rol.name),
            (this.filters.usuario_id = this.datosLogin.id);

            if (this.$session.has("detalle_cliente_id")) {
                this.$router.push("/clientes_nominas");
            }

            if (this.rol == "admin") {
                this.checador.headers = [
                { text: "Nombre", value: "nombre", class: "cabecera-tabla" }
                ];
                this.empleado.cliente_id = this.filters.cliente_id = this.datosLogin.cliente_id;
            } 
            else if (this.rol == "admin-empresa") {
                this.empleado.empresa_id = this.filters.empresa_id = this.datosLogin.empresa_id;
            } 
            else if (this.rol == "admin-sucursal") {
                this.empleado.sucursal_id = this.filters.sucursal_id = this.datosLogin.sucursal_id;
            } 
            else if (this.rol == "admin-depto") {
                this.empleado.departamento_id = this.filters.departamento_id = this.datosLogin.departamento_id;
            }

            this.parametros_base = {
                activo: true,
                paginate: false,
                order: "asc",
                cliente_id: this.empleado.cliente_id,
                empresa_id: this.empleado.empresa_id,
                sucursal_id: this.empleado.sucursal_id,
                departamento_id: this.empleado.departamento_id
            };
        },
        async abrirModal(accion, item = null) {
            await this.resetValue();
            this.errors.clear();
            this.accion = accion;
            this.getCategoriasEmpleado()

            if (accion == "checadores") {
                this.titulo_modal = "Checadores activos";
                this.tamModal = "700";
                this.empleado_checador_id = { id: item.id, clave: item.clave };
                this.getChecadores(item.id);
                this.setFiltersChecador(item.id);
                this.ImagenModal = "/static/modal/checadores.svg";
            } 
            else {
                this.ImagenModal = "/static/modal/empleadoCreate.svg";
                this.finaliza_carga = false;
                //this.getContratosFormatos();
                this.getEstadosCiviles();

                if (accion == "add") {
                    this.init();
                    this.updateEmpleado = false;
                    this.titulo_modal = "Registrar empleado";
                    this.tamModal = "900";
                    this.getParametros();
                    
                    this.empleado.foto = "/static/avatar/usuario4.jpg";
                    this.getBrigadas();
                    this.getPeriodicidades();
                    this.getTiposRegimenes();


                    if (this.rol == "root") {
                        this.getClientes();
                    }
                    if (this.rol == "admin") {
                        //this.cambiaCliente(this.datosLogin.cliente_id, this.accion);
                        this.cliente_value = this.datosLogin.cliente_id;
                    }
                    if (this.rol == "admin-empresa") {
                        this.cliente_value = this.datosLogin.cliente_id;
                        this.empresa_value = this.datosLogin.empresa_id;
                        
                        //this.cambiaEmpresa(this.datosLogin.empresa_id, this.accion);
                    }
                    if (this.rol == "admin-sucursal") {
                        this.cliente_value = this.datosLogin.cliente_id;
                        this.empresa_value = this.datosLogin.empresa_id;
                        this.sucursal_value = this.datosLogin.sucursal_id;
                        //this.cambiaSucursal(this.datosLogin.sucursal_id, this.accion);
                    }

                    if(this.$session.get('empleadoBorrador')){
                        this.empleado.nombre                    =   this.$session.get('empleadoBorrador').nombre;
                        this.empleado.apellido_paterno          =   this.$session.get('empleadoBorrador').apellido_paterno;
                        this.empleado.apellido_materno          =   this.$session.get('empleadoBorrador').apellido_materno;
                        this.empleado.nacionalidad              =   this.$session.get('empleadoBorrador').nacionalidad;
                        this.empleado.sexo                      =   this.$session.get('empleadoBorrador').sexo;
                        this.empleado.estado_civil_id           =   this.$session.get('empleadoBorrador').estado_civil_id;
                        this.empleado.tiene_hijos               =   this.$session.get('empleadoBorrador').tiene_hijos;
                        this.empleado.fecha_nacimiento          =   this.$session.get('empleadoBorrador').fecha_nacimiento;
                        setTimeout(()=>this.$refs.FechaNacimiento.setDate(this.$session.get('empleadoBorrador').fecha_nacimiento),200);
                        this.empleado.direccion                 =   this.$session.get('empleadoBorrador').direccion;


                        this.busca_cp                           =   this.$session.get('empleadoBorrador').cp_id;
                        this.empleado.colonia_id                =   this.$session.get('empleadoBorrador').colonia_id;
                        this.empleado.telefono                  =   this.$session.get('empleadoBorrador').telefono;
                        this.empleado.nivel_estudios_id         =   this.$session.get('empleadoBorrador').nivel_estudios_id;
                        this.empleado.correo                    =   this.$session.get('empleadoBorrador').correo;
                        
                        this.empleado.cliente_id                =   this.$session.get('empleadoBorrador').cliente_id;
                        this.empleado.empresa_id                =   this.$session.get('empleadoBorrador').empresa_id;
                        this.empresaVal                         =   this.$session.get('empleadoBorrador').empresa_id;
                        this.empleado.sucursal_id               =   this.$session.get('empleadoBorrador').sucursal_id;
                        this.empleado.departamento_id           =   this.$session.get('empleadoBorrador').departamento_id;
                        this.empleado.horario_id                =   this.$session.get('empleadoBorrador').horario_id;
                        this.empleado.puesto_id                 =   this.$session.get('empleadoBorrador').puesto_id;

                        this.cliente_value                      =   this.$session.get('empleadoBorrador').cliente_id;
                        this.empresa_value                      =   this.$session.get('empleadoBorrador').empresa_id;
                        this.sucursal_value                     =   this.$session.get('empleadoBorrador').sucursal_id;
                        
                        this.empleado.fecha_ingreso             =   this.$session.get('empleadoBorrador').fecha_ingreso;
                        setTimeout(()=>this.$refs.FechaIngreso.setDate(this.$session.get('empleadoBorrador').fecha_ingreso),200);

                        this.empleado.prestacion_id             =   this.$session.get('empleadoBorrador').prestacion_id;
                        this.empleado.clave_interna             =   this.$session.get('empleadoBorrador').clave_interna;
                        this.empleado.tipo_contrato_id          =   this.$session.get('empleadoBorrador').tipo_contrato_id;
                        this.empleado.dias_contrato             =   this.$session.get('empleadoBorrador').dias_contrato;
                        this.empleado.brigada_proteccion_civil_id = this.$session.get('empleadoBorrador').brigada_proteccion_civil_id;
                        this.empleado.salario_diario            =   this.$session.get('empleadoBorrador').salario_diario;
                        this.empleado.rfc                       =   this.$session.get('empleadoBorrador').rfc;
                        this.empleado.curp                      =   this.$session.get('empleadoBorrador').curp;


                    }
                    this.finaliza_carga = true;
                } 
                else if (accion == "update") {
                    await this.getLoadKardexCollections(item);
                    this.getPeriodicidades();
                    
                    this.updateEmpleado             = true;
                    this.titulo_modal               = "Actualizar empleado";
                    this.ImagenModal                = "/static/modal/empleadoUpdate.svg";
                    this.tamModal                   = "900";
                    this.empleado.foto              = this.urlImg + item.foto;
                    this.empleado.foto_default      = item.foto;
                    this.empleado.id                = item.id;
                    this.empleado.nombre            = item.nombre;
                    this.empleado.apellido_materno  = item.apellido_materno;
                    this.empleado.apellido_paterno  = item.apellido_paterno;
                    this.empleado.nacionalidad      = item.nacionalidad;
                    this.empleado.fecha_nacimiento  = item.fecha_nacimiento;
                    this.empleado.sexo              = item.sexo;
                    this.empleado.direccion         = item.direccion;
                    this.empleado.telefono          = item.telefono;
                    this.empleado.correo            = item.correo;
                    this.empleado.fecha_ingreso     = item.fecha_ingreso;
                    this.empleado.fecha_baja        = item.fecha_baja;
                    this.empleado.dia_descanso      = item.dia_descanso;
                    this.empleado.tiene_hijos       = item.tiene_hijos;
                    this.empleado.clave_interna     = item.clave_interna;
                    this.empleado.email_anterior    = this.empleado.correo;
                    this.empleado.dias_vacaciones   = item.dias_vacaciones;
                    this.cliente_value              = item.cliente_id;
                    this.empresa_value              = item.empresa_id;
                    this.sucursal_value             = item.sucursal_id;
                    this.empleado.departamento_id   = item.departamento_id;
                    this.empleado.horario_id        = item.horario_id;
                    this.empleado.mejora_continua   = item.mejora_continua;
                    this.empleado.ambiente_laboral  = item.ambiente_laboral;
                    this.empleado.estado_civil_id   = item.estado_civil_id;

                    this.empleado.puesto_id         = item.puesto_id;
                    this.empleado.colonia_id        = item.colonia_id;
                    this.empleado.nivel_estudios_id = item.nivel_estudios_id;
                    this.empleado.municipio_id      = item.municipio_id;
                    this.empleado.prestacion_id     = item.prestacion_id;
                    this.empleado.tipo_contrato_id  = item.tipo_contrato_id;
                    this.empleado.brigada_proteccion_civil_id =  item.brigada_proteccion_civil_id;
                    this.empleado.cursos_capacitaciones = item.objCursos;
                    this.empleado.salario_diario    = item.salario_diario;
                    this.empleado.periodicidad_id   = item.periodicidad_id;
                    this.empleado.tipo_regimen_sat_id= item.tipo_regimen_sat_id;
                    this.empleado.dias_contrato = item.dias_contrato;
                    this.empleado.rfc               = item.rfc;
                    this.empleado.curp              = item.curp;
                    this.empresaVal = item.empresa_id
                    this.contratoEmpleado.empleado_id = item.id;
                    this.contratoEmpleado.tipo_contrato_id = item.tipo_contrato_id;
                    this.contratoEmpleado.dias_contrato = item.dias_contrato;
                    this.contratoEmpleado.fecha_ingreso = item.fecha_ingreso;
                    this.empleado.direccion_contrato =  item.direccion_contrato;
                    this.empleado.empleado_categoria_id = item.empleado_categoria_id;


                    if(item.objCursos.length>0){
                        item.objCursos.forEach(itemCurso => {
                            const curso = this.itemsCursosCapacitaciones.find(element => element.id == itemCurso.curso_capacitacion_id);
                            if(curso != undefined){
                                this.itemsCapacitaciones.push(curso);
                                this.itemsCursosCapacitaciones.splice(this.itemsCursosCapacitaciones.indexOf(curso),1);
                            }
                        })
                    }

                    if (item.cliente != undefined) {
                        this.empleado.cliente_id = item.cliente_id;
                    }
                    if (item.empresa != undefined) {
                        this.empleado.empresa_id = item.empresa_id;
                        this.empresaVal = item.empresa_id
                    }
                    if (item.sucursal != undefined) {
                        this.empleado.sucursal_id = item.sucursal_id;
                    }
                    if (item.departamento != undefined) {
                        this.empleado.departamento_id = item.departamento_id;
                    }
                    if (item.horario != undefined) {
                        this.empleado.horario_id = item.horario_id;
                    }

                    await this.obtener_puestos()

                    setTimeout(function() {document.getElementById("btnModal").click(); }, 100);

                    setTimeout(()=>this.$refs.FechaIngreso.setDate(item.fecha_ingreso),200);
                    setTimeout(()=>this.$refs.FechaNacimiento.setDate(item.fecha_nacimiento),200);

                    if (item.cp_id != null) {
                        this.getCP(item.cp_id);
                    } 

                } 
                else if (accion == "baja") {
                    this.ImagenModal = "/static/bg/baja.png";
                    this.titulo_modal = "Baja de empleado";
                    this.getBajaImss();
                    this.tamModal = "500";
                    (this.baja.rol_name = this.datosLogin.rol.name),
                    (this.nombreBaja = item.nombre + " " + item.apellido_paterno);
                    this.baja.id = item.id;
                    this.baja.usuario_id = this.datosLogin.id;
                    this.baja.email = item.correo;
                    this.finaliza_carga = true;
                }
            }
            if (this.accion != "update") {
                setTimeout(function() {document.getElementById("btnModal").click();}, 100);
            }
        },
        //para el multiselect
        toggleMenu() {
            this.showMenu = true;
        },
        //multiselect
        abrirModalFoto(capturar, item = null) {
            setTimeout(() => { this.$refs.webcam.start();}, 750);
            this.showMenu = false;
            if (capturar == "capturar") {
                document.getElementById("btnModalFoto").click();
            }
            this.imgFoto = null;
        },
        onCapture() {
            this.imgFoto = this.$refs.webcam.capture();
        },
        b64toBlob(base64URL, sliceSize) {
            var arr = base64URL.split(",");
            var contentType = arr[0].match(/:(.*?);/)[1];
            var b64Data = arr[1];
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        },
        guardaFoto(){
            this.$refs.imagen = this.imgFoto;
            $("#img").attr("src", this.imgFoto);
            this.archivo_adjunto = 'Foto1.jpg';
            this.empleado.foto = this.imgFoto;
            console.log(this.archivoImagen);
            this.imgFoto = this.b64toBlob(this.imgFoto);
            const archivo = new FileReader();
                archivo.readAsDataURL(this.imgFoto);
                archivo.addEventListener("load", () => {
                this.archivoImagen = this.imgFoto;
            });
            this.dialogFoto = false;
        },
        onStarted(stream) {
            console.log("On Started Event", stream);
        },
        onStopped(stream) {
            console.log("On Stopped Event", stream);
        },
        onStop() {
            this.$refs.webcam.stop();
        },
        onStart() {
            this.$refs.webcam.start();
        },
        onError(error) {
            console.log("On Error Event", error);
        },
        onCameras(cameras) {
            this.devices = cameras;
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
        },
        async loadModalData() {
            await this.resetValue();

            let cliente = null;
            let empresa = null;
            let sucursal = null;
            let depto = null;
            this.getCategoriasEmpleado()

            if (this.rol == "root") {
                this.getClientes();
            }
            if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.cambiaCliente(this.datosLogin.cliente_id, this.accion);
                cliente = this.datosLogin.cliente_id;
            }
            if (this.rol == "admin-empresa") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.cambiaEmpresa(this.datosLogin.empresa_id, this.accion);
                empresa = this.datosLogin.empresa_id;
            }
            if (this.rol == "admin-sucursal") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.sucursal_value = this.datosLogin.sucursal_id;
                this.cambiaSucursal(this.datosLogin.sucursal_id, this.accion);
                sucursal = this.datosLogin.sucursal_id;
            }
            if (this.rol == "admin-depto") {
                depto = this.datosLogin.departamento_id;
            }

            let param = {
                activo          : true,
                paginate        : false,
                cliente_id      : cliente,
                empresa_id      : empresa,
                sucursal_id     : sucursal,
                departamento_id : depto,
                rol_name        : this.datosLogin.rol.name,
                usuario_id      : this.datosLogin.id
            };

            empleadosApi.getEmpleados(param).then(response => {
                let formateado = response.data;
                formateado.forEach(element => {
                    let nombre = element["nombre"];
                    let apellido_paterno = element["apellido_paterno"];
                    element["nombre_completo"] = nombre + " " + apellido_paterno;
                });
                this.nombre_completo_empleados = formateado;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los empleados");
            });
        },
        setFilters() {
            let fecha_inicio    = this.fecha_inicio;
            let fecha_final     = this.fecha_final;
            let fecha_inicio_c  = this.fecha_inicio_c;
            let fecha_final_c   = this.fecha_final_c;
            let cliente         = this.cliente_value;
            let empresa         = this.empresa_value;
            let sucursal        = this.sucursal_value;
            let departamento    = this.empleado.departamento_id;
            //let correo          = this.nombre_completo_correo;
            let empleado_correo = this.advancedSearch.empleado_correo;
            let correo_search   = this.correo_search;
            let categoria_empleado = this.categoria_empleado

            let cliente_id;
            let empresa_id;
            let sucursal_id;
            let departamento_id;

            if (this.rol == "admin") {
                cliente_id = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                empresa_id = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                sucursal_id = this.datosLogin.sucursal_id;
            } else if (this.rol == "admin-depto") {
                departamento_id = this.datosLogin.departamento_id;
            }



            let filterParams = {
                min_fecha_ingreso   : fecha_inicio,
                max_fecha_ingreso   : fecha_final,
                min_fecha_nacimiento: fecha_inicio_c,
                max_fecha_nacimiento: fecha_final_c,
                cliente_id          : cliente,
                empresa_id          : empresa,
                sucursal_id         : sucursal,
                departamento_id     : departamento,
                categoria_id        : categoria_empleado,
                correo              : correo_search,
                nombre_completo     : empleado_correo
            };

            let defaultParams = {
                activo: true,
                paginate: true,
                include_padres: true,
                rol_name: this.datosLogin.rol.name,
                usuario_id: this.datosLogin.id
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filters = defaultParams;

            this.fecha_inicio = null;
            this.fecha_final = null;
            this.fecha_inicio_c = null;
            this.fecha_final_c = null;
            this.cliente_value = null;
            this.empresa_value = null;
            this.sucursal_value = null;
            this.empleado.departamento_id = null;
            this.nombre_completo_correo = null;
            this.advancedSearch.empleado_correo = null;
            this.correo_search  = null;
            this.categoria_empleado = null
        },
        setFiltersChecador(id) {
            let filterParams = {};

            let defaultParams = {
                activo: true,
                paginate: true,
                empleado_id: id
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filtrosChecador = defaultParams;
        },
        cerrarModalRenovar(){
            this.dialogRenovar = false;
        },
        cerrarModal() {
            this.resetValue();
            this.dialog = false;
            this.dialogLayout = false;
            this.showMenu = false;
            this.dialogLayoutEmpleados = false;
            this.isSaving       = false;
            this.$session.remove("empleadoBorrador");
        },
        omitirFoto() {
            //this.dialogFoto = false;
            this.imgFoto = null;
            //this.$refs.webcam.stop();
            setTimeout(() => {this.$refs.webcam.start();}, 550);
            //await this.onstop();
            //await this.onStart();
        },
        cerrarModalFoto(){
            this.dialogFoto = false;
            this.archivo_adjunto = 'Subir archivo';
            setTimeout(() => { this.$refs.webcam.stop();}, 550);
        },
        resetValue() {
            this.empleado.id                = 0;
            this.empleado.nombre            = null;
            this.empleado.apellido_paterno  = null;
            this.empleado.apellido_materno  = null;
            this.empleado.nacionalidad      = null;
            this.empleado.fecha_nacimiento  = null;
            this.empleado.sexo              = "M";
            this.empleado.direccion         = null;
            this.empleado.estado_id         = null;
            this.empleado.codigo_postal     = null;
            this.empleado.telefono          = "";
            this.empleado.correo            = null;
            this.empleado.estado_civil_id   = 1;
            this.empleado.fecha_ingreso     = null;
            this.empleado.fecha_baja        = null;
            this.empleado.dia_descanso      = "0";
            this.empleado.cliente_id        = null;
            this.empleado.empresa_id        = null;
            this.empleado.sucursal_id       = null;
            this.empleado.departamento_id   = null;
            this.empleado.ambiente_laboral  = true;
            this.empleado.mejora_continua   = false;
            this.empleado.horario_id        = null;
            this.empleado.tiene_hijos       = false;
            this.empleado.puesto            = null;
            this.empleado.foto              = "";
            this.empleado.foto_default      = null;
            this.empleado.email_anterior    = null;
            this.empleado.prestacion_id     = null;
            this.empleado.tipo_contrato_id  = null;
            this.empleado.brigada_proteccion_civil_id = null;
            this.empleado.cursos_capacitaciones = [];
            this.empleado.salario_diario    = null;
            this.empleado.periodicidad_id   = null;
            this.empleado.tipo_regimen_sat_id= null;
            this.empleado.rfc               = null;
            this.empleado.curp              = null;
            this.empleado.direccion_contrato= null;
            this.empleado.dias_vacaciones   = null;
            //this.empleado.segundo_contrato_tipo_contrato_id = null;
            this.empleado.empleado_categoria_id = null;

            this.itemsBrigadas              = [];
            this.itemsCursosCapacitaciones  = [],
            this.modelCursosCapacitaciones  = [], 
            this.cursos_capacitaciones_eliminadas = [];
            this.itemsCapacitaciones        = [];
            this.curso_id                   = null;
            this.evaluacion                 = null;
            this.observaciones              = null;
            
            this.prestacion_id              = null;
            this.clave_interna              = null;
            this.estado_id                  = "";
            this.sucursal_id                = "";
            this.departamento_id            = "";
            this.clientes                   = [];
            this.prestaciones               = [];
            this.empresas                   = [];
            this.sucursales                 = [];
            this.departamentos              = [];
            this.cliente_value              = null;
            this.empresa_value              = null;
            this.sucursal_value             = null;
            this.departamento_value         = null;
            this.horarios                   = [];
            this.ciudades                   = [];
            this.estados                    = [];
            this.loading_guardar            = false;
            this.conteo_parametros          = 0;
            this.estados_civiles            = [];
            this.nombre_archivo             = "";
            this.archivo                    = {
                archivo     : null,
                cliente_id  : null,
                empresa_id  : null,
                sucursal_id : null,
                rol_name    : null,
            };
            this.menu_final                 = false;
            this.menu_inicio                = false;
            this.fecha_final                = null;
            this.fecha_inicio               = null;
            this.menu_inicio_c              = false;
            this.menu_final_c               = false;
            this.fecha_inicio_c             = null;
            this.fecha_final_c              = null;
            this.email_anterior             = null;
            this.empleado.clave_interna     = null;
            this.nombre_completo_empleados  = [];
            this.nombre_completo_correo     = null;
            this.archivoImagen              = null;
            this.mColonia                   = false;
            this.nombreImagen               = "";
            this.archivo_adjunto            = 'Subir archivo';
            $("#avatar").val("");
            $("#texto").text("");
            $("#img").attr(
                "src",
                "/static/avatar/usuario4.jpg"
            ); 
            this.baja               = {
                id                  : null,
                accion              : "Baja",
                motivo              : "",
                fecha               : "",
                usuario_id          : null,
                email               : "",
                tipo_baja_imss_id   : null,
            };
            this.empleado.puesto_id         = null;
            this.empleado.nivel_estudios_id = null;
            this.empleado.cp_id             = null;
            this.empleado.municipio_id      = null;
            this.empleado.colonia_id        = null;
            this.busca_cp                   = "";
            this.estado                     = "";
            this.ciudad                     = "";
            this.accion_guardar             = false;
            this.updateEmpleado             = false;
            this.modelDiasContrato          = 30;
            this.correo_search              = null;
            this.categoria_empleado         = null;
            this.id_anterior = null
            this.id_nuevo = null

            this.determinado = false;

            if(this.$refs.FechaNacimiento != undefined || this.$refs.FechaNacimiento != null){
                this.$refs.FechaNacimiento.resetDate();
            }
            if(this.$refs.FechaIngreso != undefined || this.$refs.FechaIngreso != null){
                this.$refs.FechaIngreso.resetDate();
            }
            if(this.$refs.FechaInicio != undefined || this.$refs.FechaInicio != null){
                this.$refs.FechaInicio.resetDate();
            }
            if(this.$refs.FechaFinal != undefined || this.$refs.FechaFinal != null){
                this.$refs.FechaFinal.resetDate();
            }
            if(this.$refs.FechaBaja != undefined || this.$refs.FechaBaja != null){
                this.$refs.FechaBaja.resetDate();
            }

            this.$nextTick(() => {
                if(this.$refs.form != undefined || this.$refs.form != null){
                    this.$refs.form.reset();
                } 

                if(this.$refs.form2 != undefined || this.$refs.form2 != null){
                    this.$refs.form2.reset();
                } 
            });   
        },
        async getParametros(cp = null) {
            let self = this;
            await catalogoApis.getEstudios(this.parametros_base).then(response => {
                self.estudios = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los estados.");
            });
        },
        async getClientes(clientes = null) {
            let param = { activo: true, paginate: false };
            await clientesApi.getClientes(param).then(response => {
                this.clientes = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes");
            });
        },
        getPrestaciones() {
            let param = {
                activo: true,
                paginate: false,
                order: "asc",
                cliente_id: this.cliente_value,
                empresa_id: this.empresa_value
            };
            prestacionApi.find(param).then(response => {
                this.prestaciones = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las prestaciones");
            });
        },
        async getEmpresas() {
            let parametros = { activo: true, paginate: false };
            await empresaApi.getEmpresas(parametros).then(response => {
                this.empresas = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        async cambiaCliente(cliente, accion = null) {
            let param = { activo: true, paginate: false, cliente_id: cliente };
            await empresaApi.getEmpresas(param).then(response => {
                this.empresas = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        async cambiaEmpresa(empresa, accion = null) {
            let parametros = { activo: true, paginate: false, empresa_id: empresa };
            await sucursalApi.getSucursales(parametros).then(response => {
                this.sucursales = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        async cambiaSucursal(sucursal, accion = null) {
            let parametros = { activo: true, paginate: false, sucursal_id: sucursal };
            await departamentoApi.getDepartamentos(parametros).then(response => {
                this.departamentos = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los departamentos.");
            });

            let parametrosHorario = {
                activo: true,
                paginate: false,
                sucursal_id: sucursal
            };
            horariosApi.getHorarios(parametrosHorario).then(response => {
                this.horarios = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los horarios.");
            });


        
            let paramPuesto= { activo: true, paginate: false, order: "asc", sucursal_id : this.sucursal_value };
                this.puestos= []
            await puestoApi.getPuestos(paramPuesto).then(response => {
                this.puestos = response.data
                /* let format = response.data
                if(format.length != 0){
                    format.forEach(item =>{
                        item.claveNombre = `${item.clave} - ${item.nombre}`
                        this.puestos.push(item)
                    })
                } */
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los puestos.");
            });
        },
        async cambiaDepartamento(departamento, accion = null) {
            let parametros = {
                activo: true,
                paginate: false,
                departamento_id: departamento
            };
            await horariosApi.getHorarios(parametros).then(response => {
                this.horarios = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los horarios.");
            });
        },
        async getEstadosCiviles(estado_civil = null) {
            let param = { activo: true, paginate: false };
            await estadosCivilesApi.getEstadosCiviles(param).then(response => {
                this.estados_civiles = response.data;
                if (estado_civil != null) {
                    this.empleado.estado_civil_id = estado_civil;
                }
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los estados civiles.");
            });
        },
        async getCategoriasEmpleado(){
            let parametros = {
                activo: true,
            }
            await categoriaEmpleadoApi.getCategoriasEmpleado(parametros).then(response => {
                this.categoriasEmpleado = response.data
            }).catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los tipos de empleado.")
            })
        },
        finaliza_parametros() {
            this.finaliza_carga = false;
            this.conteo_parametros = this.conteo_parametros + 1;
            if (this.accion == "add" && this.conteo_parametros >= 3) {
                this.finaliza_carga = true;
                this.validarImagen();
            }
            if (this.accion == "update" && this.conteo_parametros >= 8) {
                this.finaliza_carga = true;
                this.validarImagen();
            }
            if (this.accion == "baja") {
                this.finaliza_carga = true;
            }
        },
        eliminar(id, empleado, email) {
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el colaborador?",
                "Eliminar",
                () => {
                    let idEmpleado = id;
                    let accion = "Eliminar";
                    let usuario_id = this.datosLogin.id;
                    let param = {
                        rol_name: this.datosLogin.rol.name,
                        id: idEmpleado,
                        accion: accion,
                        usuario_id: usuario_id,
                        email: email
                    };
                    empleadosApi.eliminarEmpleado(param).then(response => {
                        this.$refs.tableEmpleados.getData();
                        this.listar();
                        Notify.Success(
                            "Colaborador eliminado",
                            "El colaborador ha sido eliminado satisfactoriamente."
                        );
                    })
                    .catch(err => {
                        Notify.ErrorToast(error.response.data.message);
                    });
                }
            );
        },
        bajaEmpleado() {
            this.$refs.form.validate().then(result => {
                if (result) {
                    empleadosApi.eliminarEmpleado(this.baja).then(response => {
                        this.$refs.tableEmpleados.getData();
                        this.listar();
                        this.cerrarModal();
                        Notify.Success("Baja de colaborador","El colaborador ha sido dado de baja satisfactoriamente.");
                    })
                    .catch(err => {
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            });
        },
        guardar() {
            let self = this;
            
            //this.$validator.validate().then(async result => {
            this.$refs.form.validate().then(result => {
                if (!result) {
                    return;
                }
                try {
                    if (
                        self.validarFormatoFecha(self.empleado.fecha_nacimiento) == false ||
                        self.validarFormatoFecha(self.empleado.fecha_ingreso) == false
                    ) {
                        Swal.fire({
                            position: "center",
                            type: "error",
                            title: "Error",
                            text: "El formato de la fecha es incorrecto.",
                            showConfirmButton: true
                        });
                    } 
                    else {
                        if (
                            self.existeFecha(self.empleado.fecha_nacimiento) == false ||
                            self.existeFecha(self.empleado.fecha_ingreso) == false
                        ) {
                            Swal.fire({
                                position: "center",
                                type: "error",
                                title: "Error",
                                text: "La fecha introducida no existe.",
                                showConfirmButton: true
                            });
                        } 
                        else {
                            self.validaContrato();
                            
                        }
                    }
                } 
                catch (error) {
                    Swal.fire({
                        position: "center",
                        type: "error",
                        title: "Error",
                        text: "El formato de la fecha es incorrecto.",
                        showConfirmButton: true
                    });
                }
            });
        },
       validaContrato(){
            if(this.accion == "update"){
                
                if(this.empleado.id == this.contratoEmpleado.empleado_id ){
                    if(this.empleado.tipo_contrato_id != this.contratoEmpleado.tipo_contrato_id ||
                        this.empleado.dias_contrato != this.contratoEmpleado.dias_contrato ||
                        this.empresa_value != this.empresaVal ||
                        this.empleado.fecha_ingreso != this.contratoEmpleado.fecha_ingreso ){
                        
                        this.renovarRegenerar = true;
                        this.dialogRenovar = true;
                        return;
                    }
                }

               /* if(this.empleado.id == this.contratoEmpleado.empleado_id){
                    if(this.empleado.tipo_contrato_id != this.contratoEmpleado.tipo_contrato_id 
                    || this.empleado.dias_contrato != this.contratoEmpleado.dias_contrato){
                        this.renovarRegenerar = true;
                        this.dialogRenovar = true;
                        return;
                    }else if(this.empresa_value != this.empresaVal){
                        this.renovarRegenerar = true;
                        this.dialogRenovar = true;
                        return;
                    }
                }*/
            }
            
            this.loading_guardar = true;
            this.guardarValido();
        },
        
        /*
        Entrada:
        Salida:
        Descripción: Ejecuta el API renovarContrato() enviando los 
                     parametros tomados del contrato seleccionado
                     y actualiza la tabla para mostrar los cambios.
        */
        async renovarContrato(){
            this.dialogRenovar = false;

            let params = {"empleado_id": this.empleado.id,
                          "tipo_contrato_id": this.empleado.tipo_contrato_id,
                          "dias": this.empleado.dias_contrato};

            this.loading_guardar = true;
            if(await this.guardarValido()){
                await apiContrato
                .renovarContrato(params)
                .then((response) => {
                    
                })
                .catch((err) => {
                    this.loading_guardar = false;
                    this.respuesta_error(err);
                });
            }
        },

        /*
        Entrada:
        Salida:
        Descripción: Ejecuta el API regenerarContrato() enviando los 
                     parametros tomados del contrato seleccionado
                     y actualiza la tabla para mostrar los cambios.
        */
        async regenerarContrato(){
            this.dialogRenovar = false;

            let params = {  
                "empleado_id": this.empleado.id,
                "anterior_id": this.id_anterior,
                "nuevo_id": this.id_nuevo,
                "tipo": 1
                //"tipo_contrato_id": this.empleado.tipo_contrato_id,
                //"dias": this.empleado.dias_contrato,
            }

            //console.log(params)
            
            this.loadingGuardar = true;
            if(await this.guardarValido()){
                apiContrato
                .regenerarContrato(params)
                .then((response) => {
                    
                })
                .catch((err) => {
                    this.loadingGuardar = false;
                    this.respuesta_error(err);
                });
            }
        },
        /*aqui termina el guardar */
        async guardarValido() {
            let self = this;
            let response_request = null;

            this.empleado.cliente_id = this.cliente_value;
            this.empleado.empresa_id = this.empresa_value;
            this.empleado.sucursal_id = this.sucursal_value;
            let formData = new FormData();

            formData.append("tipo", "gdth");

            let existeImagen = false;

            if(this.archivoImagen != null){
                formData.append("archivo", this.archivoImagen); /*imagen para el form data*/
                existeImagen = true
            }
            formData.append("nombre", this.empleado.nombre.toString());
            formData.append("apellido_paterno",this.empleado.apellido_paterno.toString());
            formData.append("nacionalidad",this.empleado.nacionalidad.toString());
            formData.append("apellido_materno",this.empleado.apellido_materno?this.empleado.apellido_materno.toString():'');
            formData.append("fecha_nacimiento", this.empleado.fecha_nacimiento.toString());
            formData.append("sexo", this.empleado.sexo.toString());
            formData.append("direccion", this.empleado.direccion.toString());
            formData.append("estado_id", this.empleado.estado_id.toString());
            formData.append("municipio_id", this.empleado.municipio_id.toString());
            formData.append("cp_id", this.empleado.cp_id.toString());
            formData.append("colonia_id", this.empleado.colonia_id.toString());
            formData.append("puesto_id", this.empleado.puesto_id.toString());

            let mejora   = this.empleado.mejora_continua  ? "1" : "0";
            let ambiente = this.empleado.ambiente_laboral ? "1" : "0";

            formData.append("mejora_continua", mejora);
            formData.append("ambiente_laboral", ambiente);
            formData.append("nivel_estudios_id", this.empleado.nivel_estudios_id.toString());

            formData.append("telefono", this.empleado.telefono.toString());
            formData.append("correo", this.empleado.correo ? this.empleado.correo.toString():'');
            formData.append("fecha_ingreso", this.empleado.fecha_ingreso.toString());
            formData.append("horario_id", this.empleado.horario_id.toString());
            formData.append("estado_civil_id",this.empleado.estado_civil_id);
            formData.append("tiene_hijos", this.empleado.tiene_hijos.toString());
            formData.append("usuario_id", this.datosLogin.id.toString());
            formData.append("cliente_id", this.empleado.cliente_id.toString());
            formData.append("empresa_id", this.empleado.empresa_id.toString());
            formData.append("sucursal_id", this.empleado.sucursal_id.toString());
            formData.append( "prestacion_id",this.empleado.prestacion_id.toString());
            formData.append("departamento_id",this.empleado.departamento_id.toString());
            formData.append("tipo_contrato_id", this.empleado.tipo_contrato_id);
            formData.append("dias_vacaciones", this.empleado.dias_vacaciones);
            formData.append("salario_diario", this.empleado.salario_diario);
            formData.append("periodicidad_id", this.empleado.periodicidad_id);
            formData.append('tipo_regimen_sat_id', this.empleado.tipo_regimen_sat_id);
            formData.append("rfc",this.empleado.rfc.toString());
            formData.append("curp",this.empleado.curp.toString());
            if(this.empleado.empleado_categoria_id != null && this.empleado.empleado_categoria_id != '' && this.empleado.empleado_categoria_id != 0){
                formData.append('empleado_categoria_id', parseFloat(this.empleado.empleado_categoria_id.toString()));
            }
            else{
                formData.append('empleado_categoria_id','');
            }

            //Generar dos contratos
           /*  if(this.dosContratos && this.accion == 'add' && this.empleado.segundo_contrato_tipo_contrato_id != ""){
                formData.append("generarDosContratos","true");
                formData.append("segundo_contrato_tipo_contrato_id", this.empleado.segundo_contrato_tipo_contrato_id.toString());
            } */

            if(this.empleado.direccion_contrato != "" && this.empleado.direccion_contrato != null){
                formData.append("direccion_contrato", this.empleado.direccion_contrato);
            }

            if (this.empleado.clave_interna == null) {
                formData.append("clave_interna", "");
            } else {
                formData.append("clave_interna",this.empleado.clave_interna.toString());
            }

            if(this.empleado.brigada_proteccion_civil_id != null && this.empleado.brigada_proteccion_civil_id != "" ){
                formData.append("brigada_proteccion_civil_id", this.empleado.brigada_proteccion_civil_id);
            }

            let cursos_cap = JSON.stringify(this.empleado.cursos_capacitaciones);
            formData.append('cursos_capacitaciones', cursos_cap);
            let cursos_eli = JSON.stringify(this.cursos_capacitaciones_eliminadas);
            formData.append('cursos_capacitaciones_eliminadas', cursos_eli);
            

            if (this.accion === "add") {
                let contrato = this.contratos.find(item => item.id == this.empleado.tipo_contrato_id);
                let clave = contrato.tipo_contrato? contrato.tipo_contrato.clave : contrato.clave_formato;
                if(clave == '03'){
                    formData.append("dias_contrato", this.empleado.dias_contrato);
                }
                await empleadosApi.addEmpleado(formData).then(response => {
                    this.$refs.tableEmpleados.getData();
                    response_request = response;
                    this.respuesta_ok("Se ha realizado la operación correctamente.");
                })
                .catch(err => {
                    this.respuesta_error(err);
                    this.loading_guardar = false;
                    return false;
                });
            } 
            else if (this.accion === "update") {
                let updateFoto = false;
                updateFoto = this.empleado.foto_default;
                formData.append("id", this.empleado.id);
                formData.append("update_foto", updateFoto);
                formData.append("email_anterior", this.empleado.email_anterior);
                let contrato = this.contratos.find(item => item.id == this.empleado.tipo_contrato_id);
                let clave = contrato.tipo_contrato? contrato.tipo_contrato.clave : contrato.clave_formato;
              
                if(clave == '03'){
                    formData.append("dias_contrato", this.empleado.dias_contrato);
                }

                await empleadosApi.updateEmpleado(formData).then(response => {
                    this.$refs.tableEmpleados.getData();
                    response_request = response;
                    this.cerrarModalRenovar()
                })
                .catch(err => {
                    this.respuesta_error(err);
                    this.cerrarModalRenovar()
                    this.loading_guardar = false;
                    return false;
                });
            }

            if (response_request != null && existeImagen == true) {
                let resultFaceList = await this.getFaceList(response_request);
                await this.faceListUpload(response_request, resultFaceList);
            }

            if(response_request != null){
                this.respuesta_ok("Se ha realizado la operación correctamente.");
                return true;
            }
                
        },/*Guardar valido */
        async getFaceList(data) {
            let isCreated = false;
            let responseData;
            let listFaces = [];

            await cognitiveServicesApi.getFaceList(data.empleado.empresa_id).then(async response => {
                //si recibe un status 200
                responseData = response; 
                isCreated = true;
            })
            .catch(error => {
                return false;
            });
            
            if(isCreated){
                await cognitiveServicesApi.getFaces(responseData.largeFaceListId).then(async response =>{
                    listFaces = response
                }).catch(error => console.log(error))

                    listFaces.forEach(item =>{
                        if(item.userData == data.empleado.id){
                            cognitiveServicesApi.deleteFace(responseData.largeFaceListId,item.persistedFaceId)
                        }
                    })
            }
            return isCreated;
        },
        async faceListUpload(data, isCreated = false) {
            if (!isCreated) {
                let listParams = {
                    name: data.empleado.empresa_id,
                    userData: `Empresa-${data.empleado.empresa_id}`
                };

                

                await cognitiveServicesApi.createFaceList(data.empleado.empresa_id, listParams).then(response => {
                    console.log("FACELIST", response);
                })
                .catch(error => console.log(error));
            }

            if (this.archivoImagen != null) {
                await cognitiveServicesApi.addFace(
                    data.empleado.empresa_id,
                    { url: this.urlImg + data.empleado.foto },
                    data.empleado.id
                )
                .then(response => console.log("ADDFACE", response))
                .catch(error => console.log(error));

                await cognitiveServicesApi
                .train(data.empleado.empresa_id)
                .then(response => console.log("TRAIN EXITOSO"))
                .catch(error => console.log(error));
            }
        },
        async getChecadores(id) {
            this.finaliza_carga = false;
            let params = {
                paginate: false,
                empleado_id: id
            };
            this.checadores = [];
            relojApi.getEmpleados(params).then(response => {
                this.checadores = response.data;
                this.finaliza_carga = true;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las dispositivos.");
            });
        },
        eliminar_checador(item) {
            let empleados = [];
            let self = this;
            empleados.push(item.empleado_id)
            let param = {
                checador_id: parseInt(item.id),
                empleados: empleados,
            };
            Notify.Alert(
                "ADVERTENCIA",
                "¿Esta seguro que desea eliminar el checador?",
                "Eliminar",
                () => {
                    dispositivosApi.dropEmpleado(param).then(response => {
                        this.getChecadores(item.empleado_id);
                        this.respuesta_ok("Cliente eliminado");
                    })
                    .catch(err => {
                        this.respuesta_error(err);
                    });
                }
            );
        },
        respuesta_error(err) {
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        respuesta_ok(msj = "") {
            this.listar();
            this.cerrarModal();
            this.resetValue();
            this.dialog = false;
            Notify.Success("Operación exitosa", msj);
        },
        detalle_documentos(data) {
            this.$session.remove("documentos");
            this.$session.set("documentos", data);
            this.$router.push("/documentos");
        },
        async layout() {
            let self = this;
            this.overlayDesgarga = true;
            let url = "empleados/layout";
            const FileDownload = require("js-file-download");
            var today = new Date();
            let nombre;
            this.isSaving = true;
            if (this.rol == "admin" || this.rol == "root") {
                this.$refs.form.validate().then(success => {
                    if(!success) {
                        this.isSaving = false;
                        return;
                    }
                })


                nombre =
                    "layout_de_importacion_de_empleados_" +
                    today.getDate() +
                    "_" +
                    (today.getMonth() + 1) +
                    "_" +
                    today.getFullYear() +
                    "_" +
                    today.getHours() +
                    "-" +
                    today.getMinutes() +
                    "-" +
                    today.getSeconds() +
                    ".xlsx";
                var object1 = {
                    rol_name: "admin-empresa",
                    cliente_id: this.cliente_value,
                    empresa_id: this.empresa_value,
                    sistema     : "gdth"
                };
            }
            if (this.rol == "admin-empresa") {
                nombre =
                    "layout_de_importacion_de_empleados_" +
                    today.getDate() +
                    "_" +
                    (today.getMonth() + 1) +
                    "_" +
                    today.getFullYear() +
                    "_" +
                    today.getHours() +
                    "-" +
                    today.getMinutes() +
                    "-" +
                    today.getSeconds() +
                    ".xlsx";
                var object1 = {
                    rol_name: this.rol,
                    cliente_id: this.datosLogin.cliente_id,
                    empresa_id: this.datosLogin.empresa_id,
                    sistema     : "gdth"
                };
            }
            if (this.rol == "admin-sucursal") {
                nombre =
                   "layout_de_importacion_de_empleados_" +
                    today.getDate() +
                    "_" +
                    (today.getMonth() + 1) +
                    "_" +
                    today.getFullYear() +
                    "_" +
                    today.getHours() +
                    "-" +
                    today.getMinutes() +
                    "-" +
                    today.getSeconds() +
                    ".xlsx";
                var object1 = {
                    rol_name    : this.rol,
                    cliente_id  : this.datosLogin.cliente_id,
                    empresa_id  : this.datosLogin.empresa_id,
                    sucursal_id : this.datosLogin.sucursal_id,
                    sistema     : "gdth"

                };
            }
            if(this.isSaving){
                try {
                    await Vue.axios({
                        method: "GET",
                        responseType: "blob",
                        url: url,
                        params: object1
                    }).then((response, status, xhr) => {
                        FileDownload(response.data, nombre);
                        self.overlayDesgarga = false;
                        this.cerrarModal();
                    });
                } catch (e) {
                    self.overlayDesgarga = false;
                    console.log(e);
                }
            }
            
        },
        layout2() {
            let self = this;
            let url = "empleados/layout";
            const FileDownload = require("js-file-download");
            var today = new Date();
            let nombre;
            this.isSaving = true;
            this.$refs.form2.validate().then(success => {
                    if(!success) {
                        this.isSaving = false;
                        return;
                    }
                


                nombre =
                    "layout_de_importacion_de_empleados_" +
                    today.getDate() +
                    "_" +
                    (today.getMonth() + 1) +
                    "_" +
                    today.getFullYear() +
                    "_" +
                    today.getHours() +
                    "-" +
                    today.getMinutes() +
                    "-" +
                    today.getSeconds() +
                    ".xlsx";
                var object1 = {
                    rol_name    : "admin-empresa",
                    cliente_id  : this.cliente_value,
                    empresa_id  : this.empresa_value,
                    sistema     : "gdth"
                };
            
                try {
                    Vue.axios({
                        method: "GET",
                        responseType: "blob",
                        url: url,
                        params: object1
                    }).then((response, status, xhr) => {
                        FileDownload(response.data, nombre);
                        this.cerrarModal();
                    });
                } catch (e) {
                    console.log(e);
                }
            })
            
        },
        modalLayout(accion) {
            this.accionLayout = accion;
            if(accion === 'importar' ){
                this.titulo_modal_doc  = 'Subir layout para agregar empleados';
            }
            else if (accion === 'actulizacionMasivo'){
                this.titulo_modal_doc  = 'Actualización masiva';
            }
            this.archivo.cliente_id = this.datosLogin.cliente_id;
            this.archivo.empresa_id = this.datosLogin.empresa_id;
            if (this.rol == "admin-sucursal") {
                this.archivo.sucursal_id = this.datosLogin.sucursal_id;
            }
            this.archivo.rol_name = this.datosLogin.rol.name;

            setTimeout(function() {
                document.getElementById("btnModalLayout").click();
            }, 300);
        },
        guardarLayout() {
            let self = this;
            let formData = new FormData();
            formData.append("archivo", this.archivo.archivo);
            formData.append("cliente_id", this.archivo.cliente_id);
            formData.append("empresa_id", this.archivo.empresa_id);

            if (this.rol == "admin-sucursal") {
                formData.append("sucursal_id", this.archivo.sucursal_id);
            }

            formData.append("rol_name", this.archivo.rol_name);
            formData.append("usuario_id", this.datosLogin.id);
            let url = "empleados/importar";
            const FileDownload = require("js-file-download");
            const config = {
                headers: {
                responseType: "blob"
                }
            };
            if (this.nombre_archivo == "" ||this.nombre_archivo == "" || this.nombre_archivo == undefined) 
            {
                Notify.Info("Se requiere documento", "Para guardar se requiere un documento");
            } 
            else {
                this.loading_guardar = true;
                Vue.axios({
                    method: "post",
                    url: "empleados/importar",
                    responseType: "blob",
                    data: formData,
                    config: { headers: { "Content-Type": "multipart/form-data" } }
                })
                .then(function(response) {
                    if (response.status == 200) {
                        Notify.ErrorToast("Se encontraron errores en los datos");
                        FileDownload(response.data, "reporte.xlsx");
                        this.$refs.tableEmpleados.getData();
                        self.cerrarModal();
                    } 
                    else if (response.status == 202) {
                        Notify.Success("Operación exitosa");
                        self.$refs.tableEmpleados.getData();
                        self.listar();
                        self.cerrarModal();
                    } 
                    else {
                        this.$refs.tableEmpleados.getData();
                        self.cerrarModal();
                    }
                })
                .catch(err => {
                    this.$refs.tableEmpleados.getData();
                    self.cerrarModal();
                });
            }
        },
        guardarLayout2() {
            let self = this;
            this.$refs.form2.validate().then(success => {
                this.isSaving = true;
                if(!success) {
                    this.isSaving = false;
                    return;
                }
                if(this.rol == "root" || this.rol == "admin"){
                    this.archivo.cliente_id = this.cliente_value;
                    this.archivo.empresa_id = this.empresa_value;
                    this.archivo.rol_name   = "admin-empresa";
                }
                let formData = new FormData();
                formData.append("archivo", this.archivo.archivo);
                formData.append("cliente_id", this.archivo.cliente_id);
                formData.append("empresa_id", this.archivo.empresa_id);
                formData.append("tipo", 'gdth');

                if (this.rol == "admin-sucursal") {
                    formData.append("sucursal_id", this.archivo.sucursal_id);
                }

                formData.append("rol_name", this.archivo.rol_name);
                formData.append("usuario_id", this.datosLogin.id);
                let url = "empleados/importar";
                const FileDownload = require("js-file-download");
                const config = {
                    headers: {
                        responseType: "blob"
                    }
                };
                
                Vue.axios({
                    method: "post",
                    url: "empleados/importar",
                    data: formData,
                    config: { headers: { "Content-Type": "multipart/form-data" } }
                })
                .then(function(response) {
                    if (response.status == 200) {
                        //Notify.Success("Operación exitosa", "Se crearon correctamente los empleados");
                        self.cerrarModal();
                        self.dialogOverlayEmpleados = true;
                        //self.$refs.tableEmpleados.getData();
                        
                    } else if (response.status == 202) {
                        Notify.ErrorToast("Se encontraron errores en los datos");
                        self.erroresModal = response.data;
                        self.dialogErrores = true;
                        self.cerrarModal();
                        self.$refs.tableEmpleados.getData();
                        
                    } else {
                        self.cerrarModal();
                        self.$refs.tableEmpleados.getData();
                    }
                })
                .catch(err => {
                    self.isSaving = false;
                    self.dialogOverlayEmpleados = false;
                    Notify.ErrorToast("Error al subir archivo.");
                });
            });
        },
        pickFile() {
            this.$refs.image.click();
        },
        onFilePicked(e) {
            const files = e.target.files;
            if (files[0] !== undefined) {
                this.nombre_archivo = files[0].name;
                if (this.nombre_archivo.lastIndexOf(".") <= 0) {
                    return;
                }
                const fr = new FileReader();
                fr.readAsDataURL(files[0]);
                fr.addEventListener("load", () => {
                    this.archivo.archivo = files[0];
                });
            } 
            else {
                this.nombre_archivo = "";
                this.imageUrl = "";
            }
        },
        almacenarImagen() {
            this.$refs.imagen.click();
            this.showMenu = false;
            this.validarImagen();
        },
        onFilePickedImagen(evento) {
            const img = evento.target.files;
            if (img[0] !== undefined) {
                this.archivo_adjunto = this.nombreImagen = img[0].name;
                if (this.nombreImagen.lastIndexOf(".") <= 0) {
                    return;
                }
                const archivo = new FileReader();
                archivo.readAsDataURL(img[0]);
                archivo.addEventListener("load", () => {
                    this.archivoImagen = img[0];
                    $("#img").attr("src", evento.target.result);
                });
            } 
            else {
                this.nombreImagen = "";
                this.archivoImagen = null;
            }
        },
        detalleEmpleado(data) {
            this.$session.remove("detalleEmpleado");
            this.$session.set("detalleEmpleado", data);
            this.$router.push("/empleado/detalleEmpleado");
        },
        validarFormatoFecha(campo) {
            var RegExPattern = /^\d{2,4}\-\d{1,2}\-\d{1,2}$/;
            if (campo.match(RegExPattern) && campo != "" && campo != null && campo != undefined) 
            {
                return true;
            } 
            else {
                return false;
            }
        },
        existeFecha(fecha) {
            var fechaf = fecha.split("-");
            var day = fechaf[2];
            var month = fechaf[1];
            var year = fechaf[0];
            var date = new Date(year, month, "0");
            if (day - 0 > date.getDate() - 0) {
                return false;
            }
            return true;
        },
        validarImagen() {
            var self = this;
            //Cuando cambie #avatar
            $("#avatar").change(function() {
                $("#texto").text("");
                $("#img").attr("src", "");
                if (self.validarExtension(this)) {
                    if (self.validarPeso(this)) {
                        self.verImagen(this);
                    }
                }
            });
        },

        validarExtension(datos) {
            //Validacion de estensiones permitidas
            var extensionesValidas = ".png, .gif, .jpeg, .jpg";
            var ruta = datos.value;
            var extension = ruta.substring(ruta.lastIndexOf(".") + 1).toLowerCase();
            var extensionValida = extensionesValidas.indexOf(extension);
            if (extensionValida < 0) {
                Swal.fire({
                    position: "center",
                    type: "error",
                    title: "Error",
                    html:
                        "La extensión no es válida <br> Su fichero tiene de extensión: " +
                        extension,
                    showConfirmButton: true
                }).then(result => {
                    if (result.value) {
                        $("#avatar").val("");
                        $("#form").val("");
                        this.nombreImagen = "";
                        this.archivoImagen = null;
                    }
                });
                return false;
            } else {
                return true;
            }
        },
        validarPeso(datos) {
            var pesoPermitido = 1536;
            if (datos.files && datos.files[0]) {
                var pesoFichero = datos.files[0].size / 1024;
                if (pesoFichero > pesoPermitido) {
                    Swal.fire({
                        position: "center",
                        type: "error",
                        title: "Error",
                        html:
                        "El tamaño de la imagen supera el limite permitido!! <br> El peso maximo permitido del fichero es: " +
                        pesoPermitido +
                        " KB Su fichero tiene: " +
                        pesoFichero +
                        " KBs",
                        showConfirmButton: true
                    }).then(result => {
                        if (result.value) {
                            $("#avatar").val("");
                            $("#form").val("");
                            this.nombreImagen = "";
                            this.archivoImagen = null;
                        }
                    });
                    return false;
                } 
                else {
                    return true;
                }
            }
        },
        verImagen(datos) {
            if (datos.files && datos.files[0]) {
                var reader = new FileReader();
                reader.onload = function(e) {
                    $("#img").attr("src", e.target.result);
                };
                reader.readAsDataURL(datos.files[0]);
            }
        },
        abrirModalAgregar(tipo_modal=null) {
            this.componentKey += 1;
            this.finaliza_carga_agregar = true;
            this.resetValuesAgregar = false;
            if(tipo_modal == 'tPuesto'){
                this.titulo_modal_agregar = 'Agregar puesto';
                this.imgModalAgregar = "/static/modal/puesto_actualizar.svg";
                this.tPuesto    = true;
                this.tEmpresa   = false;
                this.tSucursal  = false;
                this.tDeptos    = false;
                this.tReloj     = false;
                this.$refs.autoPuesto.isMenuActive = false;
            }
            else if(tipo_modal == 'tEmpresa'){
                this.titulo_modal_agregar = 'Agregar empresa';
                this.imgModalAgregar = "/static/modal/empresa.png";
                this.tPuesto    = false;
                this.tEmpresa   = true;
                this.tSucursal  = false;
                this.tDeptos    = false;
                this.tReloj     = false;
                this.$refs.autoEmpresa.isMenuActive = false;
            }
            else if(tipo_modal == 'tSucursal'){
                this.titulo_modal_agregar = 'Agregar sucursal';
                this.imgModalAgregar = "/static/modal/sucursal.png";
                this.$session.set("idEmpresaEmpleado", this.empresa_value);
                this.tPuesto    = false;
                this.tEmpresa   = false;
                this.tSucursal  = true;
                this.tDeptos    = false;
                this.tReloj     = false;
                this.$refs.autoSucursal.isMenuActive = false;

            }
            else if(tipo_modal == 'tDepto'){
                this.titulo_modal_agregar = 'Agregar departamento';
                this.imgModalAgregar = "/static/modal/departamento.png";
                this.tPuesto    = false;
                this.tEmpresa   = false;
                this.tSucursal  = false;
                this.tDeptos    = true;
                this.tReloj     = false;
                this.$refs.autoDepartamento.isMenuActive = false;
            }
            else if(tipo_modal == 'tHorario'){
                this.titulo_modal_agregar = "Registrar horario";
                this.imgModalAgregar = "/static/bg/dia_fetivo.png";
                this.tPuesto    = false;
                this.tEmpresa   = false;
                this.tSucursal  = false;
                this.tDeptos    = false;
                this.tReloj     = true;
                this.$refs.autoHorario.isMenuActive = false;
            }
            setTimeout(function() {
                document.getElementById("btnModal_agregar").click();
            }, 100);
        },
        obtener() {
            this.valor = true;
        },
        cerrarModalAgregar(){
            this.dialog_agregar = false;
            this.loading_guardar_agregar = false;
            this.resetValuesAgregar = true;
            this.idEmpresa = false;
        },
        guardarAgregar(valores){
            this.loading_guardar_agregar = true;
            if(valores.status == 'puesto'){
                let valoresPuesto = {
                    cliente_id  : this.cliente_value,
                    empresa_id  : this.empresa_value,
                    sucursal_id : this.sucursal_value,
                    funciones   : valores.funciones,
                    id          : 0,
                    nombre      : valores.nombre,
                    objetivo    : valores.objetivo,
                    objetivo_ias: valores.objetivo_ias,
                    plazas      : valores.plazas,
                    sueldo      : valores.sueldo,
                    sueldo_maximo: valores.sueldo_maximo
                }
                puestoApi.addPuesto(valoresPuesto).then((response) => {
                    Notify.Success("Operación exitosa", "Se creó el nuevo puesto satisfactoriamente.");
                    this.cerrarModalAgregar();
                    this.obtener_puestos();
                    this.empleado.puesto_id = response.id;
                    this.resetValuesAgregar = true;
                })
                .catch((err) => {
                    this.respuesta_error(err);
                    this.loading_guardar_agregar = false;
                });
                this.valor = false;
            }
            else if(valores.status == 'tEmpresa'){
                if(valores.url_server_asp == "" || valores.url_server_asp == null){
                    delete valores.url_server_asp;
                }
                valores.cliente_id = this.cliente_value;
                
                empresaApi.addEmpresa(valores).then((response) => {
                    Notify.Success("Operación exitosa", "Se creó la nueva empresa satisfactoriamente.");
                    this.cerrarModalAgregar();
                    this.obtener_empresas();
                    this.empresa_value = response.id;
                    this.resetValuesAgregar = true;
                })
                .catch((err) => {
                    this.respuesta_error(err);
                    this.loading_guardar_agregar = false;
                });
                this.valor = false;
            }
            else if(valores.status == 'sucursal'){
                let valoresSuc = {
                    id              : 0,
                    nombre          : valores.nombre,
                    cliente_id      : this.cliente_value,
                    empresa_id      : this.empresa_value,
                    cp_id           : valores.cp_id,
                    estado_id       : valores.estado_id,
                    municipio_id    : valores.municipio_id,
                    direccion       : valores.direccion,
                    colonia_id      : valores.colonia_id,
                    coordenadas     : valores.coordenadas,
                    distancia_checada: valores.distancia_checada,
                    descripcion     : valores.descripcion,
                    
                };
                sucursalApi.addSucursal(valoresSuc).then((response) => {
                    Notify.Success("Operación exitosa", "Se ha creado la sucursal correctamente.");
                    this.cerrarModalAgregar();
                    this.obtenerSucursales();
                    this.sucursal_value = response.id;
                })
                .catch((err) => {
                    this.respuesta_error(err);
                    this.loading_guardar_agregar = false;
                });
                this.valor = false;
            }
            else if(valores.status == 'depto'){
                let valoresDep= {
                    id          : 0,
                    nombre      : valores.nombre,
                    encargado   : valores.encargado,
                    correo      : valores.correo,
                    descripcion : valores.descripcion,
                    sucursal_id : this.sucursal_value,
                    empresa_id  : this.empresa_value,
                    cliente_id  : this.cliente_value
                };
                departamentoApi.addDepartamento(valoresDep).then((response) => {
                    Notify.Success("Operación exitosa", "Se ha creado el departamento correctamente.");
                    this.cerrarModalAgregar();
                    this.obtenerDepartamentos();
                    this.empleado.departamento_id = response.id;
                })
                .catch((err) => {
                    this.respuesta_error(err);
                    this.loading_guardar_agregar = false;
                });
                this.valor = false;
            }
            else if(valores.status == 'horarios'){        
                let valoresHorario = {
                    id                  :0,
                    nombre              : valores.nombre,
                    descripcion         : valores.descripcion,
                    minutos_tolerancia  : valores.minutos_tolerancia,
                    detalles_horario    : valores.detalles_horario,
                    detalles_eliminados : valores.detalles_eliminados,
                    jornada_id          : valores.jornada_id,
                    cliente_id          : this.cliente_value,
                    empresa_id          : this.empresa_value,
                    sucursal_id         : this.sucursal_value,
                };
                if(valoresHorario.detalles_horario.length == 0 ){
                    this.valor = false;
                    this.loading_guardar_agregar = false;
                    Notify.ErrorToast("Es requerido agregar al menos un día con horario");
                }
                else{
                    horariosApi.addHorario(valoresHorario).then((response) => {
                        Notify.Success("Operación exitosa", "Se ha creado el horario correctamente.");
                        this.cerrarModalAgregar();
                        this.obtenerHorarios();
                        this.empleado.horario_id = response.id;
                    })
                    .catch((err) => {
                        this.respuesta_error(err);
                        this.loading_guardar_agregar = false;
                    });
                    this.valor = false;
                }
            }
        },
        oyenteFalse(){
            this.loading_guardar_agregar = false;
            this.valor = false;
        },
        resetValorGuardar(){
            this.valor = false;
        },
        obtener_puestos(){
            let self = this;
            let params = {
                activo: true,
                paginate: false,
                order: "asc",
                cliente_id: this.cliente_value,
                empresa_id: this.empresa_value,
                sucursal_id: this.sucursal_value,
                departamento_id: this.departamento_value
            }
            this.puetos = []
            puestoApi.getPuestos(params).then(response => {
                this.puestos = response.data
                
            })               
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los puestos.");
            });
        },
        obtener_empresas(){
            let self = this;
            let parametros = { activo: true, paginate: false, cliente_id: this.datosLogin.cliente_id };
            empresaApi.getEmpresas(parametros).then(response => {
                self.empresas = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        obtenerSucursales(){
            let self = this;
            let parametros = { activo: true, paginate: false, cliente_id: this.datosLogin.cliente_id, empresa_id: this.empresa_value};
            sucursalApi.getSucursales(parametros).then(response => {
                self.sucursales = response.data;
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.")
            })
        },
        obtenerDepartamentos(){
            let self = this;
            let parametros = { activo: true, paginate: false, sucursal_id: this.sucursal_value };
            departamentoApi.getDepartamentos(parametros).then(response => {
                self.departamentos = response.data;
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los departamentos.")
            })
        },
        obtenerHorarios(){
            let self = this;
            let parametros = { activo: true, paginate: false, sucursal_id: this.sucursal_value };
            horariosApi.getHorarios(parametros).then(response => {
                self.horarios =  response.data;
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los horarios");
            })
        },
        getTiposContratosSAT(){
            let parametros = { activo:true, paginate:false, order:"asc" }
            apiTipoContratoSAT.find(parametros).then((response) => {
                let format = response.data;
                if(response.data.length != 0){
                    format.forEach( item => {
                        item.claveDescripcion = item.clave + ' - ' + item.descripcion
                        this.contratos.push(item);
                    })
                }
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los tipos de contratos.");
            });
        },
        async getContratosFormatos(){
            let parametros = { 
                activo:true, 
                paginate:false, 
                order:"asc", 
                cliente_id: this.cliente_value,
                empresa_id:this.empresa_value, 
                tipo:"EMPLEADOS", 
                sistema:'gdth'
            }
            await apiContrato.find(parametros).then((response) => {
                this.contratos = response.data;
                this.contratos.map(item => {
                    let rp = item.nombre_registro_patronal !== null ? " - "+item.nombre_registro_patronal:""
                    item.claveDescripcion = item.clave_formato+" - "+item.nombre+rp;
                });
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los tipos de contratos.");
            });
        },
        async getBajaImss() {
            let param = { activo: true, paginate: false };
            await apiTipoBajaImss.find(param).then(response => {
                this.tipos_baja_imss = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los tipos de baja IMSS");
            });
        },
        async getLoadKardexCollections(objEmpleado){
            let parametros = { empleado_id:parseInt(objEmpleado.id), rol_name:this.rol}
            await empleadosApi.getKardexCollections(parametros).then((response) => {
                this.colonias           = response.colonias;
                this.estudios           = response.escolaridades;
                this.clientes           = response.clientes;
                this.empresas           = response.empresas;
                this.sucursales         = response.sucursales;
                this.departamentos      = response.departamentos;
                this.horarios           = response.horarios;
                this.puestos            = response.puestos;
                this.prestaciones       = response.prestaciones;
                //this.estadosCFDI        = response.estados;
                this.itemsBrigadas      = response.Brigadas;
                this.itemsCursosCapacitaciones = response.Cursos;
                let formatRegimenes = response.tiposRegimenes;              
                formatRegimenes.forEach( item => {
                    item.claveDescripcion = item.clave + ' - ' + item.descripcion
                    this.tiposRegimenesSAT.push(item);
                })
                this.contratos  = response.tipos_contratos;
                this.contratos.map(item => {
                    let rp = item.registro_patronal !== null ? " - "+item.registro_patronal.nombre:""
                    item.claveDescripcion = item.tipo_contrato.clave+" - "+item.nombre+rp;
                });
                
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los datos.");
            });
        },
        storeDraft() {
            if(this.empleado.rfc!=null){
                this.empleado.rfc = this.empleado.rfc.toUpperCase();
            }
            
            this.empleado.estado_id     = this.estado;
            this.empleado.municipio_id  = this.municipio;
            this.empleado.cp_id         = this.busca_cp;
            this.empleado.cliente_id    = this.cliente_value;
            this.empleado.empresa_id    = this.empresa_value;
            this.empleado.sucursal_id   = this.sucursal_value;
            
            this.$session.remove("empleadoBorrador");
            this.$session.set('empleadoBorrador', this.empleado);
            Notify.Success("Operación exitosa", "El empleado se guardo en sesión correctamente");
            this.dialog = false;
        },
        async getBrigadas(){
            let param = { activo: true, paginate: false };
            await apiBrigadas.find(param).then(response => {
                this.itemsBrigadas = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las brigadas");
            });
        },
        async getCapacitaciones(){
            let param = { activo: true, paginate: false, cliente_id: this.cliente_value, empresa_id: this.empresa_value };
            await apiCapacitaciones.find(param).then(response => {
                this.itemsCursosCapacitaciones = response.data;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las capacitaciones.");
            });
        },
        agregarCurso(){
            let self = this;
            if( this.curso_id   == null || this.curso_id   == "" ||
                this.evaluacion == null || this.evaluacion == ""  ){
                Notify.ErrorToast("Favor de agregar todo los campos.");
            }
            else if(parseInt(this.evaluacion) < 0 || parseInt(this.evaluacion) > 100){
                Notify.Warning("La evaluación tiene que estar en el rango de 0 a 100")
            }
            else{
                const curso = this.itemsCursosCapacitaciones.find(element => element.id == this.curso_id);
                let empleado_id = 0 
                if(this.accion === 'update'){
                    empleado_id = this.empleado.id;
                }
                
                let cursos = {
                    id                      : 0,
                    empleado_id             : empleado_id,
                    curso_capacitacion_id   : this.curso_id, 
                    evaluacion              : parseInt(this.evaluacion), 
                    observaciones           : this.observaciones, 
                    curso_capacitacion      : {nombre: curso.nombre},
                    nombre                  : curso.nombre
                }
                self.empleado.cursos_capacitaciones.push(cursos);

                self.itemsCapacitaciones.push(curso);
                self.itemsCursosCapacitaciones.splice(self.itemsCursosCapacitaciones.indexOf(curso),1);
                
                self.curso_id = null;
                self.evaluacion = null;
                self.observaciones = null;
            }
        },
        eliminaCurso(index,item){
            let id = {"id":item.id};
            this.cursos_capacitaciones_eliminadas.push(id);
            const curso = this.itemsCapacitaciones.find(element => element.id == item.curso_capacitacion_id);
            this.itemsCursosCapacitaciones.push(curso);
            this.empleado.cursos_capacitaciones.splice(index,1);
        },
        exportar(){
            let self = this;
            this.overlayDesgarga = true;
            let url = "empleados/exportar";
            const FileDownload = require("js-file-download");
            var today = new Date();
            let nombre;
            this.isSaving = true;

            if(this.rol == 'root' || this.rol == 'admin'){
                this.$refs.form2.validate().then(success => {
                        if(!success) {
                            this.isSaving = false;
                            return;
                        }
                    nombre =
                        "empleados_" +
                        today.getDate() +
                        "_" +
                        (today.getMonth() + 1) +
                        "_" +
                        today.getFullYear() +
                        "_" +
                        today.getHours() +
                        "-" +
                        today.getMinutes() +
                        "-" +
                        today.getSeconds() +
                        ".xlsx";
                    var object1 = {
                        rol_name    : "admin-empresa",
                        cliente_id  : this.cliente_value,
                        empresa_id  : this.empresa_value,
                        sistema     : "gdth"
                    };
                
                    try {
                        Vue.axios({
                            method: "GET",
                            responseType: "blob",
                            url: url,
                            params: object1
                        }).then((response, status, xhr) => {
                            FileDownload(response.data, nombre);
                            self.overlayDesgarga = false;
                            this.cerrarModal();
                        }).catch((error)=>{
                            if(error.response.status == 403){
                                //console.log(error.response.data)
                                if(error.response.headers["content-type"]){
                                    if(error.response.headers["content-type"] == "sinEmpleados"){
                                        //console.log(decodeURIComponent(escape(error.response.headers["content-type"])));
                                        Notify.ErrorToast("La empresa no cuenta con  empleados.");
                                    }
                                    self.overlayDesgarga = false;
                                    this.isSaving = false
                                    this.cerrarModal();
                                }
                                else{
                                    console.log(error.response)
                                }
                            }
                            else{
                                console.log(error.response);
                                Notify.ErrorToast("Algo ha salido mal, intenta de nuevo o consulta a soporte técnico.");
                            }
                        });
                    } catch (e) {
                        self.overlayDesgarga = false;
                        this.isSaving = false
                        console.log(e)
                    }
                })
            }
            else{
                nombre =
                    "empleados_" +
                    today.getDate() +
                    "_" +
                    (today.getMonth() + 1) +
                    "_" +
                    today.getFullYear() +
                    "_" +
                    today.getHours() +
                    "-" +
                    today.getMinutes() +
                    "-" +
                    today.getSeconds() +
                    ".xlsx";
                var object1 = {
                    rol_name    : this.rol,
                    cliente_id  : this.datosLogin.cliente_id,
                    empresa_id  : this.datosLogin.empresa_id,
                    sucursal_id : this.datosLogin.sucursal_id,
                    sistema     : "gdth"
                };
            
                try {
                    Vue.axios({
                        method: "GET",
                        responseType: "blob",
                        url: url,
                        params: object1
                    }).then((response, status, xhr) => {
                        FileDownload(response.data, nombre);
                        self.overlayDesgarga = false;
                        this.cerrarModal();
                    }).catch((error)=>{
                        if(error.response.status == 403){
                            if(error.response.headers["content-type"]){
                                if(error.response.headers["content-type"] == "sinEmpleados"){
                                    //console.log(decodeURIComponent(escape(error.response.headers["content-type"])));
                                    Notify.ErrorToast("La empresa no cuenta con empleados.");
                                }
                                self.overlayDesgarga = false;
                                this.isSaving = false
                                this.cerrarModal();
                            }
                            else{
                                console.log(error.response)
                            }
                        }
                        else{
                            console.log(error.response);
                            Notify.ErrorToast("Algo ha salido mal, intenta de nuevo o consulta a soporte técnico.");
                        }
                    });
                } catch (e) {
                    self.overlayDesgarga = false;
                    this.loading_guardar = false
                    console.log(e)
                }
            }
        },
        actulizacionMasivo(){
            let self = this;
            this.$refs.form2.validate().then(success => {
                this.isSaving = true;
                if(!success) {
                    this.isSaving = false;
                    return;
                }
                if(this.rol == "root" || this.rol == "admin"){
                    this.archivo.cliente_id = this.cliente_value;
                    this.archivo.empresa_id = this.empresa_value;
                    this.archivo.rol_name   = "admin-empresa";
                }
                let formData = new FormData();
                formData.append("archivo", this.archivo.archivo);
                formData.append("cliente_id", this.archivo.cliente_id);
                formData.append("empresa_id", this.archivo.empresa_id);
                formData.append("tipo", 'gdth');

                if (this.rol == "admin-sucursal") {
                    formData.append("sucursal_id", this.archivo.sucursal_id);
                }

                formData.append("rol_name", this.archivo.rol_name);
                formData.append("usuario_id", this.datosLogin.id);
                const FileDownload = require("js-file-download");
                const config = {
                    headers: {
                        responseType: "blob"
                    }
                };
                
                Vue.axios({
                    method: "post",
                    url: "empleados/update-masivo",
                    data: formData,
                    config: { headers: { "Content-Type": "multipart/form-data" } }
                })
                .then(function(response) {
                    if (response.status == 200) {
                        //Notify.Success("Operación exitosa", "Se actualizaron correctamente los empleados");
                        self.cerrarModal();
                        self.dialogOverlayEmpleados = true;
                        //self.$refs.tableEmpleados.getData();
                    } else if (response.status == 202) {
                        Notify.ErrorToast("Se encontraron errores en los datos");
                        self.erroresModal = response.data;
                        self.dialogErrores = true;
                        self.cerrarModal();
                        self.$refs.tableEmpleados.getData();
                        
                    } else {
                        self.cerrarModal();
                        self.$refs.tableEmpleados.getData();
                    }
                })
                .catch(err => {
                    self.isSaving = false;
                    Notify.ErrorToast("Error al subir archivo.");
                });
            });
        },
        getPeriodicidades(){
            let parametros = {
                activo      : true, 
                paginate    : false,
                order       : 'asc'
            }
            apiPeriodicidad.find(parametros).then(response =>{
                this.periodicidades = response.data;
            })
            .catch(err => {
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            });
        },
        async getTiposRegimenes(){
            let parametros = { activo:true, paginate:false, order:"asc" }
            await apiTipoRegimen.find(parametros).then((response) => {
                let format = response.data;
                if(response.data.length != 0){
                    format.forEach( item => {
                        item.claveDescripcion = item.clave + ' - ' + item.descripcion
                        this.tiposRegimenesSAT.push(item);
                    })
                }
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los Tipos de regímenes.");
            });
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
        cerrarModalErrores(){
            this.dialogErrores = false;
            this.erroresModal = [];
        },

        abrirModalSueldo(tipo){
            this.tipoSueldo = tipo;
            this.guardarEdicionSueldo = 'guardar';
            this.nombre_completo_sueldo = this.empleado.nombre + ' ' + this.empleado.apellido_paterno + ' ' + (this.empleado.apellido_materno!=null?this.empleado.apellido_materno:'');

            this.colaborador.valor = this.empleado.salario_diario;
            //this.colaborador.fecha_de_aplicacion_anterior = this.empleado.salarioMinimo.fecha_de_aplicacion;
            let parametros = {
                empleado_id : parseInt(this.empleado.id)
            };
            this.dialogSueldo = true;
            this.isLoadingModalSueldo = true;
            this.datosTabla = [];
            
            apiIncrementoSalarial.historial(parametros).then((response) => {
                this.isLoadingModalSueldo = false;
                this.datosTabla = response;
            })
            .catch(err => {
                this.isLoadingModalSueldo = false;
                if(typeof err.response.data.error === 'string'){
                    Notify.ErrorToast(err.response.data.error);
                }else{
                    let error = Object.values(err.response.data.error);
                    let leyenda = ``;

                    for (var i = 0; i < error.length; i++) {
                        leyenda+= `* ` + error[i] + `\n`;
                    }
                    Notify.ErrorToast(leyenda);
                }
            });
            
        },
        cerrarModalSueldo(){
            this.dialogSueldo = false;
            this.guardarEdicionSueldo = 'guardar';
            this.colaborador            = {
                id                      : null,
                nombre_completo         : null,
                empleado_id             : null,
                salario_anterior        : null,
                sbc_anterior            : null,
                salario_nuevo           : null,
                sbc_nuevo               : null,
                fecha_de_aplicacion     : null,
                tipo                    : 'fijo',
                valor                   : null,
                salario_base_cotizacion : null,
                sbc_fijo                : null,
                sbc_variable            : null,
                nuevo_sbc_fijo          : null,
                nuevo_sbc_variable      : null,
                anterior_sbc_fijo       : null,
                anterior_sbc_variable   : null,
                fecha_de_aplicacion_anterior : null
            };
            this.$nextTick(() => {
                if(this.$refs.formIncremento){
                    this.$refs.formIncremento.reset();
                }

                if(this.$refs.FechaAplicacion != undefined || this.$refs.FechaAplicacion != null){
                    this.$refs.FechaAplicacion.resetDate();
                }
            })
        },

        async guardarSueldo(){
            this.colaborador.empleado_id            = parseInt(this.empleado.id);
            this.colaborador.salario_anterior       = this.empleado.salario_diario;
            //this.colaborador.sbc_anterior           = this.empleado.salario_base_cotizacion;
            //this.colaborador.anterior_sbc_fijo      = this.empleado.sbc_fijo;
            //this.colaborador.anterior_sbc_variable  = this.empleado.sbc_variable;
            this.colaborador.salario_nuevo          = this.colaborador.valor;
            //this.colaborador.nuevo_sbc_fijo         = this.colaborador.sbc_fijo;
            //this.colaborador.nuevo_sbc_variable     = this.colaborador.sbc_variable;

            let parametros = {
                empleados : [
                    this.colaborador
                ],
                sistema:'gdth',
                tipo:'unico'
            }
            this.isSavingSueldo = true;
            apiIncrementoSalarial.guardar(parametros).then((response)=>{
                Notify.Success("Operación exitosa", "La operación se realizó correctamente.");
                this.isSavingSueldo = false;
                this.datosTabla = [];
                this.getEmpleado();
                this.cerrarModalSueldo();
            })
            .catch(err => {
                this.isSavingSueldo = false;
                if(typeof err.response.data.error === 'string'){
                    Notify.ErrorToast(err.response.data.error);
                }else{
                    let error = Object.values(err.response.data.error);
                    let leyenda = ``;

                    for (var i = 0; i < error.length; i++) {
                        leyenda+= `* ` + error[i] + `\n`;
                    }

                    Notify.ErrorToast(leyenda);
                }
            });
        },

        editarModalSueldo(itemSueldo){
            this.guardarEdicionSueldo = 'edicion';
            this.colaborador.id                     = itemSueldo.id;
            this.colaborador.empleado_id            = itemSueldo.empleado_id;
            this.colaborador.fecha_de_aplicacion_anterior = itemSueldo.fecha_de_aplicacion_anterior;
            this.colaborador.fecha_de_aplicacion    = itemSueldo.fecha_de_aplicacion;
            this.colaborador.valor                  = itemSueldo.nuevo_sueldo;
            this.colaborador.sbc_fijo               = itemSueldo.nuevo_sbc_fijo;
            this.colaborador.sbc_variable           = itemSueldo.nuevo_sbc_variable;
        },
        async guardarEdicion(){
            let parametros = { 
                id                  : this.colaborador.id,
                empleado_id         : parseInt(this.empleado.id), 
                fecha_de_aplicacion : this.colaborador.fecha_de_aplicacion,
                salario_nuevo       : this.colaborador.valor,
                nuevo_sbc_fijo      : this.colaborador.sbc_fijo,
                nuevo_sbc_variable  : this.colaborador.sbc_variable,
                fecha_de_aplicacion_anterior : this.colaborador.fecha_de_aplicacion
            };
            this.isSavingSueldo = true;
            await apiIncrementoSalarial.updateHistorial(parametros).then(async (response)=>{
                Notify.Success("Operación exitosa", "La actualizacion se realizó satisfactoriamente.");
                this.colaborador            = {
                    id                      : null,
                    nombre_completo         : null,
                    empleado_id             : null,
                    salario_anterior        : null,
                    sbc_anterior            : null,
                    salario_nuevo           : null,
                    sbc_nuevo               : null,
                    fecha_de_aplicacion     : null,
                    tipo                    : 'fijo',
                    valor                   : null,
                    salario_base_cotizacion : null,
                    sbc_fijo                : null,
                    sbc_variable            : null,
                    nuevo_sbc_fijo          : null,
                    nuevo_sbc_variable      : null,
                    anterior_sbc_fijo       : null,
                    anterior_sbc_variable   : null,
                    fecha_de_aplicacion_anterior : null
                };
                this.$nextTick(() => {
                    if(this.$refs.formIncremento){
                        this.$refs.formIncremento.reset();
                    }
                    if(this.$refs.FechaAplicacion != undefined || this.$refs.FechaAplicacion != null){
                        this.$refs.FechaAplicacion.resetDate();
                    }
                })
                this.isSavingSueldo = false;
                //await this.$apollo.queries.empleado.refetch();
                await this.abrirModalSueldo('sueldo');
            })
            .catch(err => {
                this.isSavingSueldo = false;;
                if(typeof err.response.data.error === 'string'){
                    Notify.ErrorToast(err.response.data.error);
                }else{
                    let error = Object.values(err.response.data.error);
                    let leyenda = ``;

                    for (var i = 0; i < error.length; i++) {
                        leyenda+= `* ` + error[i] + `\n`;
                    }

                    Notify.ErrorToast(leyenda);
                }
            });
        },
        cancelarEdicion(){
            this.colaborador            = {
                id                      : null,
                nombre_completo         : null,
                empleado_id             : null,
                salario_anterior        : null,
                sbc_anterior            : null,
                salario_nuevo           : null,
                sbc_nuevo               : null,
                fecha_de_aplicacion     : null,
                tipo                    : 'fijo',
                valor                   : null,
                salario_base_cotizacion : null,
                sbc_fijo                : null,
                sbc_variable            : null,
                fecha_de_aplicacion_anterior: null
            };
            this.$nextTick(() => {
                if(this.$refs.formIncremento){
                    this.$refs.formIncremento.reset();
                }
                if(this.$refs.FechaAplicacion != undefined || this.$refs.FechaAplicacion != null){
                    this.$refs.FechaAplicacion.resetDate();
                }
            })
            this.guardarEdicionSueldo = 'guardar';
        },
        dateFormat(fecha, tipo = 'tabla') {
            if(fecha == null){
                return;
            }
            let fecha2 = fecha.split("-");
            if(tipo == 'tabla'){
                return fecha2[2] + " / " + fecha2[1]+ " / " + fecha2[0];
            }
            else{
                return fecha2[2] + "/" + fecha2[1]+ "/" + fecha2[0];
            }
            
        },
        async getEmpleado(){
            await empleadosApi.getEmpleado(this.empleado.id).then(async (response)=>{
               this.empleado.salario_diario = response.salario_diario;
            })
            .catch(err => {
                if(typeof err.response.data.error === 'string'){
                    Notify.ErrorToast(err.response.data.error);
                }else{
                    let error = Object.values(err.response.data.error);
                    let leyenda = ``;

                    for (var i = 0; i < error.length; i++) {
                        leyenda+= `* ` + error[i] + `\n`;
                    }

                    Notify.ErrorToast(leyenda);
                }
            });
        },
        socketProcesandoEmpleados(){
            window.Echo = new Echo({
                broadcaster: 'pusher',
                key: 'ASDASD2121',
                wsHost: env.serverURL.url,
                wsPort: env.pusherPort,
                wssPort: env.pusherPort,
                forceTLS: env.serverURL.tls,
                disableStats: true,
                enabledTransports: ['ws', 'wss']
            });

            window.Echo.channel(`progreso-importar-empleado-${this.datosLogin.id}`).listen('ImportarEmpleadoProgress', (e) => {
                this.dialogOverlayEmpleados = true;
                this.empleadosPorcentaje   = e.message.porcentaje;
                this.empleadosTotal        = e.message.total;      
                this.empleadosProcesados   = e.message.procesados;
                if(e.message.porcentaje == 100){
                    this.procesados = e.message.procesados;
                    this.conError   = e.message.errores;
                    this.dialogMensaje = true;

                    if(e.message.errores.length == 0){
                        this.dialogOverlayEmpleados = false;
                        if(e.message.procede == false){
                            Notify.ErrorToast("No se detecto ningún registro en el archivo.");
                        }
                        else {
                            Notify.Success("Operación exitosa");
                        }

                        this.$refs.tableEmpleados.getData();
                    }
                    else{
                        this.dialogOverlayEmpleados = false;
                        this.erroresModal = e.message.errores;
                        this.dialogErrores = true;
                        this.$refs.tableEmpleados.getData();
                    }

                    setTimeout(() => {
                        this.resetProgresoEmpleados();
                    }, 5000);
                }

                
            });
        },
        resetProgresoEmpleados(){
            this.empleadosPorcentaje     = 0;
            this.empleadosTotal          = 0;
            this.empleadosProcesados     = 0;
            this.procesados              = 0;
            this.conError                = 0;
        },
        async abrirModalClave(empleado){
            this.isLoadingChecador = true;

            this.claveEmpleado.id = empleado.id;
            this.claveEmpleado.clave = empleado.clave;
            
            await this.getClave(empleado.id);

            this.dialogClave = true;
            this.isLoadingChecador = false;

        },
        cerrarModalClave(){
            this.claveEmpleado.id = null;
            this.claveEmpleado.clave = null;
            this.claveEmpleado.claveVerificacion = null;
            this.dialogClave = false;
        },
        async getClave(idEmpleado){
            await apiRelojChecador.getCodigo(idEmpleado).then((response) => {
                this.claveEmpleado.claveVerificacion = response.codigo_verificacion;
            })
            .catch (err => {
                console.log(err);
                this.claveEmpleado.claveVerificacion = null;
            })
        },
        async generarClave(){
            let parametros = {
                empleado_id : this.claveEmpleado.id
            }
            await apiRelojChecador.generarCodigo(parametros).then((response) => {
                Notify.SuccessToast("Generación de clave exitosa.");
                this.getClave(this.claveEmpleado.id);
            })
            .catch (err => {
                console.log(err);
                this.claveEmpleado.claveVerificacion = null;
                Notify.ErrorToast("Algo ha salido mal, intenta de nuevo o consulta a soporte técnico.");
            })
        },

        /* validarDosContratos(rp_id){
            
            if(rp_id != null){
                let params = {tipo:'nominas'}
                apiContrato.validarDosContratos(rp_id,params).then((resp)=>{

                    if(resp.activar_dos_contratos == true){
                        this.dosContratos = true;
                    }else{
                        this.dosContratos = false;
                        this.empleado.generarDosContratos = false;
                    }
                }).catch((err)=>{
                    console.log('Ocurrio un error ', err);
                })
            }else{
                console.log('No cuenta con registro patronal')
                return;
            }

        }, */
        //Modal Colonia
        abrirModalColonia(){
            this.dialogColonia = true
            this.isLoadingModalColonia = false
        },

        cerrarModalColonia(){
            this.dialogColonia = false
            this.nombreColonia = null
            this.isSavingColonia = false
        },
        guardarColonia(){
            this.$refs.formColonia.validate().then(success => {
                this.isSavingColonia = true;
                if(!success){
                    this.isSavingColonia = false;
                    return
                }

                let parametros = {
                    nombre: this.nombreColonia,
                    codigo_postal_id: this.empleado.cp_id
                }

                catalogoApis.addColonia(parametros).then((res)=>{
                    Notify.Success("Operación exitosa", "La colonia se agrego correctamente")
                    this.busca_codigos(this.busca_cp)
                    this.cerrarModalColonia()
                    this.empleado.colonia_id = res.data.id
                    this.$nextTick(()=>{
                        this.$refs.formColonia.reset()
                    })
                }).catch(err =>{
                    this.isSavingColonia = false
                    if(typeof err.response.data.error === 'string'){
                        Notify.ErrorToast(err.response.data.error)
                    }else{
                        let error = Object.values(err.response.data.error)
                        let leyenda = ``

                        for(var i=0; i < error.length; i++){
                            leyenda += `*` + error[i] + `\n`
                        }
                        Notify.ErrorToast(leyenda)
                    }
                })
            })
        },

        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("empleados.store")
            this.permisos.update = permisosStorage.includes("empleados.update")
            this.permisos.delete = permisosStorage.includes("empleados.delete")
        }

    },
    created() {
        this.listar();
        this.permisosVista();
    },
    mounted() {
        this.socketProcesandoEmpleados();
        document.querySelector('#tableScroll thead tr th:nth-child(1)').style.paddingRight   = "4px";
        document.querySelector('#tableScroll thead tr th:nth-child(1)').style.width   = "150px";
        document.querySelector('#tableScroll thead tr th:nth-child(5)').style.width   = "310px";
        document.querySelector('#tableScroll thead tr th:nth-child(5)').style.paddingRight   = "8px";
        document.querySelector('#tableScroll thead tr th:nth-child(5)').style.paddingLeft   = "8px";
    },
    updated() {
        document.querySelector('#tableScroll thead tr th:nth-child(1)').style.paddingRight   = "4px";
        document.querySelector('#tableScroll thead tr th:nth-child(1)').style.width   = "150px";
        document.querySelector('#tableScroll thead tr th:nth-child(5)').style.width   = "310px";
        document.querySelector('#tableScroll thead tr th:nth-child(5)').style.paddingRight   = "8px";
        document.querySelector('#tableScroll thead tr th:nth-child(5)').style.paddingLeft   = "8px";
    },
};
</script>

<style scoped>
.titleModalTimbre{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: '600';
        font-size: 18px;
        line-height: 15px;
        letter-spacing: 0.1px;
        color: #828282;
    }
    .textTimbre{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: '500';
        font-size: 18px;
        line-height: 19px;
        letter-spacing: 0.1px;
        color: #828282;
    }
    .columnas-checador {
        background-color: #f3f4f6;
    }
    .division {
        border-top: 1px solid #c4c4c4;
    }
    .btnBaja {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600 !important;
        font-size: 13px !important;
        line-height: 18px;
        background-color: rgba(212, 16, 16, 0.8) !important;
        border-radius: 30px !important;
        color: white !important;
        width: 110px !important;
        height: 40px !important;
    }

    .nombreChecador{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #1E2245;
    }

    .ubicacionChecador {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: #828282;
    }
    .titulo-checador {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        border-bottom: 2px solid #eff1fb;
        color: #828282;
    }

    .tituloRadio {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 0.2px;
        color: #a0a4a8;
        padding-bottom: 10px;
    }

    .btnModal {
        margin-bottom: 10px !important;
        margin-top: 10px !important;
    }

    .RangoIngreso {
        font-family: Montserrat !important;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 17px !important;
        color: #1E2245 !important;
    }

    /* euicab estilos para el modal tomar foto */
    .imgChecador {
        float: left;
        width: 38px;
        height: 38px;
    }
    .tituloChecador {
        font-family: Montserrat;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 22px;
        color: #1E2245;
        margin-top: 5px !important;
        margin-left: 10px !important;
        float: left;
    }
    .textoFoto {
        width: 284px;
        height: 30px;
        left: 218px;
        top: 518px;
        padding-left: 0px 65px;

        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 15px;
        /* or 150% */

        text-align: center;

        color: #96999A;
    }
    .btn-contenedor{
        padding-left: 20%;
        padding-right: 20%;
        text-align: center; 
        display: grid;
    }
    .btn-capturar{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 18px;
        letter-spacing: 0.2px;
        display: inline-block !important;
        align-items: center;
        text-align: center;
        color: #FFFFFF;
        background: #1E2245 !important;
        box-shadow: 0px 8px 16px rgba(0, 126, 255, 0.16), inset 10px 11px 17px rgba(119, 124, 185, 0.11);
        border-radius: 80px;
        text-transform: none;
        margin-bottom: 5px !important;
    }
    .btn-omitir{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        display: inline-block !important;
        align-items: center;
        text-align: center;
        color: #96999A;
        background: transparent !important;
        border-radius: 80px;
        box-shadow: none !important;
        text-transform: none;
    }
    /* euicab fin modal tomar de fotos */
    .estiloFoto {
        font-family: "Montserrat";
        font-weight: 400 !important;
        color: #8a8fb4 !important;
        font-size: 13px !important;
        line-height: 16px;
        margin-top: -2% !important;
        padding-left: 25%;
        padding-right: 25%;
    }
    #no-background-hover::before {
        background-color: transparent !important;
        border-color: transparent!important;
    }
    /* euicab multiselectes para fotos he imagen */
    .btn-group {
        min-width: 80px;
        position: relative;
        display: inline-block;
        vertical-align: middle;
    }
    .btn-group a:hover {
        text-decoration: none;
    }
    .dropdown-toggle {
        font-family: "Montserrat" !important;
        font-size: 16px !important;
        border: 0.5px solid rgba(0, 0, 0, 0.38);
        box-sizing: border-box;
        border-radius: 8px;
        padding: 9px 45px 8px 15px;
        width: 248px !important;
        height: 56px !important;
        outline: 0;
        color: rgba(0, 0, 0, 0.6);
        min-width: 80px;
        background-color: #FFFFFF;
        transition: background 0s ease-out;
        float: none;
        box-shadow: none;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        letter-spacing: normal;
        text-align: left;
        line-height: 36px;
    }
    .dropdown-toggle:hover {
        border: 0.5px solid rgba(0, 0, 0, 0.87);
        color: rgba(0, 0, 0, 0.87);
        background: #FFFFFF;
        cursor: pointer;
    }
    .dropdown-menu {
    /*
        position: absolute;
        top: -6px;
        left: 0;
        z-index: 1000;
        float: left;
        min-width: 260px;
        padding: 5px 0;
        margin: 2px 0 0;
        list-style: none;
        font-size: 14px;
        text-align: left;
        background-color: #FFF;
        border: 1px solid #ECEEEF;
        border-radius: 4px;
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
        background-clip: padding-box;*/
        position: absolute;
        top: 0px;
        left: 0;
        z-index: 1000;
        float: left;
        min-width: 260px;
        padding: 0;
        margin: 0;
        list-style: none;
        font-size: 14px;
        text-align: left;
        background-color: #FFF;
    }
    .dropdown-menu > li > a {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 12px;
        color: #96999A;
        padding: 10px 30px;
        display: block;
        clear: both;
        white-space: nowrap;
        text-decoration: none;
    }
    .dropdown-menu > li > a:hover {
        background: #96999A;
    }
    .dropdown-menu > li {
        overflow: hidden;
        width: 100%;
        position: relative;
        margin-bottom: -29px;
    }
    .caret {
        color: #96999A;
        font-size: 18px;
        position: absolute;
        top: 7px;
        margin-left: -24px;
        vertical-align: middle;
        right: 5px;
        line-height: 36px;
    }
    li {
        list-style: none;
    }
    /*fin multiselected foto e imagen */
    /*estilo modal tomarFoto */
    .v-btn-cerrar .v-btn:hover::before {
        background-color: transparent !important;
        pointer-events: none;
    }
    .v-btn-cerrar .v-btn:hover::after {
        background-color: transparent !important;
        pointer-events: none;
    }
    .v-btn-cerrar .v-btn:hover {
        background-color: transparent !important;
        pointer-events: none;
    }
    #btnModal_agregar{
        display: none;
    }
    .cursor-pointer{
        cursor:pointer;
    }
    .checadores_frase{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: #828282;
    }
    /*fin estilo modal foto*/
    .trChecadores {
        border-bottom-style: solid;
        border-bottom-color: #E0E0E0;
        border-width: 1px;
    }
    .subtituloCapacitacion{
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #1E2245;
    }
    .menuClassFoto{
        box-shadow: none;
    }
    .menuClassAcciones{
        /* box-shadow: none; */
        border-radius: 10px!important;
        margin-top:15px;
    }
    .btnAcciones {
        width: 135px !important;
        height: 42px !important;
        border-radius: 30px;
        text-transform: capitalize;
        background:#58C5D8 !important;
        color:#FFFFFF !important;
        font-family: "Montserrat" !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 17px !important;
    }
    .btnAcciones:hover {
        width: 135px !important;
        height: 42px !important;
        border-radius: 30px;
        text-transform: capitalize;
        background:#58C5D8 !important;
        color:#FFFFFF !important;
        font-family: "Montserrat" !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 17px !important;
        box-shadow: 0px 5px 8px rgba(26, 30, 66, 0.2);
        -webkit-transform: translatey(-1px);
        transform: translatey(-1px);
    }
    .btnAccionesContenedor {
        width: 300px;
        height: 380px;
        padding-top: 30px;
        background-color: #FFF;
    }
    div.btnAccionesTitulo {
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesTitulo span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        text-align: left;
        color: #1E2245;
    }
    div.btnAccionesItem {
        width: 100%;
        cursor: pointer;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesItem span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        color: #828282;
    }
    div.btnAccionesItem:hover {
        background: #F6F6F8;
    }
    #btnModalTimbre{
        display: none;
    }
    #btnModalErrores{
        display: none;
    }

    .titleModalErrores{
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 18px;
        letter-spacing: 0.1px;
        color: #444975;
    }
    .emptyTableErrores{
        padding-top: 50px !important;
        padding-bottom: 50px !important;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        text-align: center !important;
        color: #c5c5c5;
    }
    .tbl-errores {
        border-collapse: collapse;
        width: 100%;
        margin-top: 15px;
        /* white-space: nowrap; */
        overflow-x: scroll;
        overflow-y: scroll;
    }

    .tbl-errores .tbl-header {
        background: #F6F6F6;
        border-radius: 10px;
        height: 58px;
    }
    .errorth {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        color: #828282;
        line-height: 20px;
        padding: 8px;
        text-align: left !important;
    }
    .errortd {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        color: #96999A;
        line-height: 15px;
        padding: 8px;
        text-align: left !important;
    }
    .textoTablaError01{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #1E2245;
        text-align: left !important;
    }
    .textoTablaError02{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: #828282;
        text-align: left !important;
    }
    .textoTablaError03{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        color: #EB5757;
        line-height: 17px;
        text-align: left !important;
    }
    .trDivider{
        border-bottom-style: solid; 
        border-bottom-width: 1px;
        border-bottom-color: #C4C4C4;
    }

    #btnModalSueldo{
        display: none;
    }

    .v-btn-hover:hover:before {
      background-color: transparent;
      
    }
    .v-btn-hover:before {
        display: none;
    }

    .th-tabla{
        color:#828282;
        font-family: 'Montserrat';
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 14px;
        padding: 8px;
        text-align: left;
    }

    .tbl-salario tbody{
        background:#FFFFFF;
        border-bottom-left-radius: 20px !important;
        border-bottom-right-radius: 20px !important;
        margin-bottom: 10em;
    }

    .tbl-salario tbody td{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;
        color: #828282;
        text-align: left;
    }

    .tbl-salario {
        border-collapse: collapse;
        width: 100%;
        margin-top: 15px;
        overflow-x: scroll;
        overflow-y: scroll;
    }

    .tbl-salario .tbl-header {
        background: #F6F6F6;
        border-radius: 10px;
        height: 58px;
    }
    .firstth {
        border-top-left-radius: 20px !important;
    }
    .lastth {
        border-top-right-radius: 20px !important;
    }

    .emptyTableSueldo{
        color: #c5c5c5 !important;
        background:#FFFFFF;
        font-family: "Montserrat" !important;
        font-size: 18px !important;
        font-style: normal !important;
        font-weight: 500 !important;
        line-height: 22px !important;
        padding-bottom: 50px !important;
        padding-top: 50px !important;
        text-align: center !important;
        border-bottom-left-radius: 20px !important;
        border-bottom-right-radius: 20px !important;
    }

    .thTitulos{
        border-width:1px; 
        border-color:#E0E0E0 ;
    }
    .trBody{
        border-width:1px; 
        border-color:transparent !important;
        border-bottom-style: solid ;
        margin-top: 10px!important;
        height: 42px;
    }
    .menuClassAccionesEmpleado{
        border-radius: 10px!important;
    }

    .textoTablaClave01{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #828282;
        text-align: left !important;
    }
    .textoTablaClave02{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #1E2245;
        text-align: left !important;
    }
</style>